import React, {
  useCallback,
  useEffect,
  useState,
  ChangeEvent,
  useRef,
  useMemo,
} from "react";
import styled from "styled-components";
import { SingleValue, ActionMeta } from "react-select";
import SessionActionDropdown, { options } from "./SessionActionDropdown";
import SessionActionCompletedDropdown, {
} from "./SessionActionDropdownCompleted";
import Dropdown from "./Dropdown";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import BucketIcon from "../../assets/bucket.png";
import { ReactComponent as RequestIcon } from "../../assets/request.svg";
import { ReactComponent as NewDocumentIcon } from "../../assets/create_session.svg";
import { ReactComponent as EditIconSvg } from "../../assets/edit-icon-grey.svg";
import { ReactComponent as TrashIcon } from "../../assets/trash-grey.svg";
import { ReactComponent as BookIcon } from "../../assets/grey-book-icon.svg";
import { MdOutlineEdit } from "react-icons/md";
import { FaSignal, FaBell } from "react-icons/fa";
import Counter from "./Counter";
import {
  COMPLETED_STATUS,
  STAGES_BEFORE_CAMERA_CHECK,
  TIME_ZONES,
  createOfficialLink,
  generateSecurityCredentials,
  createUserLinkForCopyDownloadPageLink,
  createUserLinkForCopySessionInvite,
  createObserverLinkForSessionInvite,
  createUserPaymentLink,
  isUserOnline,
} from "../../utils/sessionHelper";
import FloatingLabelTextarea from "./StyledTextarea";
import {
  AppDispatch,
  RootState,
  checkSessionStatus,
  deleteDocument,
  getDocument,
  getOfficials,
  getRecords,
  sendNotification,
  sendPaymentEmail,
  updateDocument,
  updateSessionDetail,
} from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { API_STATUS, API_URL } from "../../utils";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  getCredentialAnalysisStatus,
  getDevice,
  getQuizStatus,
} from "../../utils/sessionHelper";
import {
  CANCELLED_STATUS,
  SESSION_STAGES,
  START_STATUS,
} from "../../constants/sessions";
import { toast } from "react-toastify";
import {
  notaryLink,
  removeBase64Header,
  resizeSignature,
} from "../../utils/helper";
import RequestDocumentPopup from "./RequestDocumentPopup";
import UploadLinkPopup from "./UploadLinkPopup";
import { handleDownloadDoc } from "../../utils/downloadDoc";
import StepTwoPopup from "./AddDocPopop";
import SendFeedbackPopup from "./SendFedbackPopup";
import AcknowledgmentModal from "./ViewRecordModal";
import { getFromLocalStorage } from "../../utils/localStorageUtil";
import { CustomCloseButton } from "../ToasterCloseButton";

interface OptionType {
  value: string;
  label: string;
}

const notaryOwners: OptionType[] = [
  { value: "Greg Peters", label: "Greg Peters" },
  { value: "Alice Thompson", label: "Alice Thompson" },
  { value: "Emily Williams", label: "Emily Williams" },
  { value: "Daniel Brown", label: "Daniel Brown" },
];

const labelMapping: { [key: string]: string } = {
  signerName: "Signer name",
  userEmail: "Signer email",
  userPhone: "Signer phone",
  userTimezone: "Signer timezone",
  copyRecipient1: "Copy recipient 1",
  copyRecipient2: "Copy recipient 2",
  payerEmail: "Payer email",
  sessionType: "Session type",
};

const SessionSummary: React.FC<{
  session: any;
  activeScheduleTab: "scheduled" | "completed";
  handleSessionSelect: (session: any) => void;
}> = ({ session, activeScheduleTab, handleSessionSelect }) => {
  
  const { data: appointmentTypes, loading } = useSelector(
    (state: RootState) => state.session.appointmentTypes
  );
  const [editingDocumentId, setEditingDocumentId] = useState<string | null>(null);
  const [editingDocumentName, setEditingDocumentName] = useState<string>("");

  const [activeTab, setActiveTab] = useState("Session Documents");
  const dispatch = useDispatch<AppDispatch>();
  const [isRequestDocPopupVisible, setIsRequestDocPopupVisible] =
    useState(false);
  const [isSessionFeedbackPopupVisible, setIsSessionFeedbackPopupVisible] =
    useState(false);
  const [selectedSessionType, setSelectedSessionType] = useState<OptionType>(
    appointmentTypes.find((type) => type.value === session?.appointmentType) ||
    appointmentTypes[0]
  );
  const [isUploadLinkPopupOpen, setIsUploadLinkPopupOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string>("");
  const [editIframeUrl, setEditIframeUrl] = useState<string>("");

  const [selectedNotaryOwner, setSelectedNotaryOwner] = useState<OptionType>(
    notaryOwners[0]
  );
  const [textareaValue, setTextareaValue] = useState(
    session?.officialPrivateNotes || ""
  );
  const [selectedSessionStage, setSelectedSessionStage] = useState<OptionType>({
    value: session?.stage,
    label: session?.stage,
  });
  const [sessionName, setSessionName] = useState<string>("");
    const [isSignerWebRTCOk, setIsSignerWebRTCOk] = useState(false);
  const [cancelSessionNote, setCancelSessionNote] = useState<string>("");
  const [selectedDocumentSeal, setSelectedDocumentSeal] = useState<number>(
    session?.documentsCount || 0
  );
  const [updatedNotaryOwner, setUpdatedNotaryOwner] =
    useState<OptionType | null>(null);
  const [isNotaryOwnerEditable, setIsNotaryOwnerEditable] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDocumentSealEditable, setIsDocumentSealEditable] = useState(false);

  const [documentId, setDocumentId] = useState("");
  const [documents, setDocuments] = useState<any[]>([]);
  const [isCancelSessionPopupVisible, setIsCancelSessionPopupVisible] =
    useState(false);
  const [isResendSessionLinkPopupVisible, setIsResendSessionLinkPopupVisible] =
    useState(false);
  const [isSendReminderPopupVisible, setIsSendReminderPopupVisible] =
    useState(false);
  const [isSendObserverPopupVisible, setIsSendObserverPopupVisible] =
    useState(false);
  const [isCancelSessionInputFocused, setIsCancelSessionInputFocused] =
    useState(false);
  const [isRestartSessionPopupVisible, setIsRestartSessionPopupVisible] =
    useState(false);
  const [isDeleteDocPopupVisible, setIsDeleteDocPopupVisible] = useState(false);
  const [
    isDisableAudioVideoSessionPopupVisible,
    setIsDisableAudioVideoSessionPopupVisible,
  ] = useState(false);
  const [isNotesEditable, setIsNoteEditable] = useState(false);
  const [isNotesLoading, setIsNotesLoading] = useState(false);
  const [sessionRecords, setSessionRecords] = useState([]);
  const [isSessionStageEditable, setIsSessionStageEditable] = useState(false);
  const [isCancelSessionLoading, setIsCancelSessionLoading] = useState(false);
  const [isRestartSessionLoading, setIsRestartSessionLoading] = useState(false);
  const [isResendSessionLinkLoading, setIsResendSessionLinkLoading] = useState(false);
  const [isDeleteDocLoading, setIsDeleteDocLoading] = useState(false);
  const [isDocNameLoading, setIsDocNameLoading] = useState(false);
  const [isEnableDisableSessionLoading, setIsEnableDisableSessionLoading] =
    useState(false);
  const [isNameEditable, setIsNameEditable] = useState(false);
  const [isAddDocPopupOpen, setIsAddDocPopupOpen] = useState(false);
  const [isSendReminderLoading, setIsSendReminderLoading] = useState(false);
  const [isSendObserverLoading, setIsSendObserverLoading] = useState(false);
  const [includeCopyRecipient, setIncludeCopyRecipient] = useState(false);
  const [includePayer, setIncludePayer] = useState(false);
  const [reminderMessage, setReminderMessage] = useState("");
  const [observerEmail, setObserverEmail] = useState("");
  const [observerMessage, setObserverMessage] = useState("");
  const [isReminderInfoVisible, setIsReminderInfoVisible] = useState(false);

  useEffect(() => {
    if(!isSendReminderPopupVisible) {
    setReminderMessage(`Hi ${session?.user?.firstName},

Please let us know if you can still join your scheduled online notary session now. Here is the link, which you can click on your mobile phone:

${createUserLinkForCopySessionInvite(notaryLink,session?.security)}

Your notary will stay on for the next 5 minutes.

Thanks!`)
    }
  },[session])

  useEffect(() => {
    if (!isSendObserverPopupVisible) {
      setObserverEmail(session?.observerInfo?.email || "");
      setObserverMessage(getObserverInviteDefaultMessage());
    }
  }, [session, isSendObserverPopupVisible]);

  const {
    updatingSession: { loading: updateLoading },
  } = useSelector((state: RootState) => state.session);

  const [isDateEditable, setIsDateEditable] = useState(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isViewRecordModalOpen, setIsViewRecordModalOpen] = useState(false);
  const initialDate = session?.scheduledAt?._seconds
    ? moment(session.scheduledAt._seconds * 1000)
      .toDate()
    : null;
  const completedDate = session?.finishedAt?._seconds
    ? moment(session.finishedAt._seconds * 1000)
      .toDate()
    : null;
  const [officials, setOfficials] = useState<any[]>([]);
  const [sessionDate, setSessionDate] = useState<Date | null>(initialDate);
  const [completedSessionDate, setCompletedSessionDate] = useState<Date | null>(
    completedDate
  );
  const [tempDate, setTempDate] = useState<Date | null>(initialDate);
  const [isSessionDetailsEditable, setIsSessionDetailsEditable] =
    useState(false);
  const [updatedStage, setUpdatedStage] = useState<OptionType | null>(null);
  const [deleteDocId, setDeleteDocId] = useState(null);
  const [updatedDocumentSeal, setUpdatedDocumentSeal] = useState<number | null>(
    null
  );
  const [signerDetail, setSignerDetail] = useState({
    signerName: session?.user?.fullName || "",
    userEmail: session?.userEmail || session?.user?.email,
    userPhone: session?.userPhone || "",
    userTimezone: session?.userTimezone || "",
    copyRecipient1: session?.emailCopies?.[0] || "",
    copyRecipient2: session?.emailCopies?.[1] || "",
    payerEmail: session?.payerEmail || "",
    sessionType: session?.appointmentType || "",
  });
  const [isSignerDetailEditable, setIsSignerDetailEditable] = useState(false);
  const [isNotaryAdmin, setIsNotaryAdmin] = useState(false);

  const isOfficialOnline = useMemo(() => isUserOnline(session), [session]);
  const isSignerOnline = useMemo(
    () => isUserOnline(session, "signerLastOnlineAt"),
    [session]
  );

  const datePickerRef = useRef<HTMLDivElement>(null);
  const personaClientRef = useRef<any>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    console.log(session)
    let isSignerWebRTCOkTemp = false
    if (!session?.isCompleted) {
      if (session?.signerConnectivity && session?.signerConnectivity?.stats) {
        isSignerWebRTCOkTemp = true;
      }
      if (session) {
        if (!session?.userIO || !session?.userIO?.audioDevices || !session?.userIO?.videoDevices || !(session?.userIO?.audioDevices?.length && session?.userIO?.videoDevices?.length)) {
          isSignerWebRTCOkTemp = false;
        }
        else {
          isSignerWebRTCOkTemp = true;
        }
      }
      setIsSignerWebRTCOk(isSignerWebRTCOkTemp);

    }
  }, [session]);


  const handleSignerDetailChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setSignerDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "userPhone") {
      validatePhoneNumber(value);
    }
  };

  const enableEditDocument = (documentId: string, currentName: string) => {
    setEditingDocumentId(documentId);
    setEditingDocumentName(currentName);
  };

  const handleSingleDocumentDownload = async (doc: any) => {
    try {
      const fileUrl = doc.fileSealed || doc.file;
      if (!fileUrl) {
        throw new Error("No file URL found for this document.");
      }

      const parts = doc.name?.split(".") || [];
      const ext = parts.pop();
      const filename = parts.join(".");

      const response = await fetch(fileUrl, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${filename}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err: any) {
      toast.error(err.message || "Failed to download document", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };


  const updateDocumentName = (targetId: string, newName: string, documents: any) => {
    return documents.map((doc: any) => {
      if (doc.id === targetId) {
        return { ...doc, id: doc.id, name: newName };
      }
      return doc;
    }).filter(Boolean);
  }


  const saveDocumentName = async (documentId: string) => {
    try {

      setIsDocNameLoading(true);
      const updateDocumentResponse = await dispatch(
        updateDocument({ documentId: documentId, name: editingDocumentName })
      );
      if (updateDocumentResponse.meta.requestStatus == API_STATUS.fulfilled) {

        toast.success("Document name updated", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });
        const updatedDocuments = updateDocumentName(documentId, editingDocumentName, documents);
        setDocuments([...updatedDocuments]);
      } else {
        toast.error("Error while updating", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });
      }
      setIsDocNameLoading(false);
      setEditingDocumentId(null);
      setEditingDocumentName("");
    }
    catch (err: any) {
      setIsDocNameLoading(false);
    }
  };

  const cancelEditDocument = () => {
    setEditingDocumentId(null);
    setEditingDocumentName("");
  };

  const handleSignerDetailEditClick = () => {
    setIsSignerDetailEditable(true);
  };

  const handleNameEditClick = () => {
    setIsNameEditable(true);
  };

  const handleSignerDetailSave = async () => {
    let updatingSignerDetail = {};
    let updatedSession = { ...session };
    if (signerDetail.hasOwnProperty('copyRecipient1') && signerDetail.hasOwnProperty('copyRecipient2')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        emailCopies: [signerDetail.copyRecipient1, signerDetail.copyRecipient2],
      };
      updatedSession = {
        ...updatedSession,
        emailCopies: [signerDetail.copyRecipient1, signerDetail.copyRecipient2]
      }
    } else if (signerDetail.hasOwnProperty('copyRecipient1')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        emailCopies: [signerDetail.copyRecipient1],
      };
      updatedSession = {
        ...updatedSession,
        emailCopies: [signerDetail.copyRecipient1]
      }
    } else if (signerDetail.hasOwnProperty('copyRecipient2')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        emailCopies: [signerDetail.copyRecipient2],
      };
      updatedSession = {
        ...updatedSession,
        emailCopies: [signerDetail.copyRecipient2],
      }
    }
    if (signerDetail.hasOwnProperty('payerEmail')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        payerEmail: signerDetail.payerEmail,
      };
      updatedSession = {
        ...updatedSession,
        payerEmail: signerDetail.payerEmail,
      }
    }
    if (signerDetail.hasOwnProperty('userEmail')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        userEmail: signerDetail.userEmail,
      };
      updatedSession = {
        ...updatedSession,
        userEmail: signerDetail.userEmail,
      }
    }
    if (signerDetail.hasOwnProperty('signerName')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        signerName: signerDetail.signerName,
      };
      const fullName = signerDetail.signerName
      const nameParts = fullName.split(' ');
      const firstName = nameParts[0];
      const lastName = nameParts.length > 1 ? nameParts[1] : '';
      updatedSession = {
        ...updatedSession,
        user: {
          ...session.user,
          fullName,
          firstName,
          lastName
        },
      }
    }

    if (signerDetail.hasOwnProperty('userTimezone')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        userTimezone: signerDetail.userTimezone,
      };
      updatedSession = {
        ...updatedSession,
        userTimezone: signerDetail.userTimezone
      }
    }
    if (signerDetail.hasOwnProperty('userPhone')) {
      updatingSignerDetail = {
        ...updatingSignerDetail,
        userPhone: signerDetail.userPhone,
      };
      updatedSession = {
        ...updatedSession,
        userPhone: signerDetail.userPhone
      }
    }
    if (signerDetail.hasOwnProperty('sessionType')) {
      const appointment = appointmentTypes.find(item => item.type === signerDetail?.sessionType);
      updatingSignerDetail = {
        ...updatingSignerDetail,
        appointmentType: appointment?.id,
      };
      updatedSession = {
        ...updatedSession,
        appointmentType: signerDetail?.sessionType,
      }
    }
    try {
      await handleUpdateDetails(updatingSignerDetail, "signerDetail");
      handleSessionSelect({
        ...updatedSession
      });
      setIsSignerDetailEditable(false);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const handleNameSave = async () => {
    let updatingSignerDetail = {};
    updatingSignerDetail = {
      ...updatingSignerDetail,
      name: sessionName,
    }
    try {
      await handleUpdateDetails(updatingSignerDetail, "sessionName");

      handleSessionSelect({
        ...session,
        ...updatingSignerDetail,
      });
      setIsSignerDetailEditable(false);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const handleRequestDoc = async () => {
    setIsUploadLinkPopupOpen(false);
    setIsRequestDocPopupVisible(true);
  };

  const handleSessionFeedback = async (officialFeedback: string) => {
    try {
      await handleUpdateDetails({ officialFeedback }, "sessionFeedback");

      handleSessionSelect({
        ...session,
        officialFeedback,
      });
      setIsSessionFeedbackPopupVisible(false);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const openSessionFeedback = async () => {
    setIsSessionFeedbackPopupVisible(true);
  };

  const handleSessionTypeChange = (
    newValue: SingleValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => {
    if (newValue) {
      setSelectedSessionType(newValue);

      setSignerDetail((prevState) => ({
        ...prevState,
        sessionType: newValue.value || "",
      }));
    }
  };

  const handleChangeSessionStage = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      if (newValue && newValue.value !== session?.stage) {
        setSelectedSessionStage(newValue);
        setUpdatedStage(newValue);
        setIsSessionStageEditable(true);
      } else {
        setIsSessionStageEditable(false);
      }
    },
    [session]
  );

  const handleDocumentSealChange = (newValue: number) => {
    if (newValue !== session?.documentsCount) {
      setSelectedDocumentSeal(newValue);
      setUpdatedDocumentSeal(newValue);
      setIsDocumentSealEditable(true);
    } else {
      setIsDocumentSealEditable(false);
    }
  };

  const handleNameChange = (event: any) => {
    setSessionName(event.target.value);
  };

  const handleCopyAppointmentId = () => {
    if (session?.appointmentId) {
      navigator.clipboard
        .writeText(session.appointmentId)
        .then(() => {
          toast.info("Appointment ID copied", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        })
        .catch(() => {
          toast.error("Failed to copy Appointment ID.", {
            autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false,
            icon: () => null,
          });
        });
    }
  };

  const handleSignerDetailCancel = () => {
    setIsSignerDetailEditable(false);
    setSignerDetail({
      signerName: session?.user?.fullName || "",
      userEmail: session?.userEmail || session?.user?.email,
      userPhone: session?.userPhone || "",
      userTimezone: session?.userTimezone || "",
      copyRecipient1: session?.emailCopies[0] || "",
      copyRecipient2: session?.emailCopies[1] || "",
      payerEmail: session?.payerEmail || "",
      sessionType: session?.appointmentType || "",
    });
  };
  const handleNameCancel = () => {
    setIsNameEditable(false);
  };

  const openCancelSessionPopup = () => setIsCancelSessionPopupVisible(true);
  const closeCancelSessionPopup = () => setIsCancelSessionPopupVisible(false);

  const openResendSessionLinkPopup = () => setIsResendSessionLinkPopupVisible(true);
  const openSendReminderPopup = () => setIsSendReminderPopupVisible(true);
  const openSendObserverPopup = () => setIsSendObserverPopupVisible(true);
  const closeResendSessionLinkPopup = () => setIsResendSessionLinkPopupVisible(false);
  const closeSendReminderPopup = () => setIsSendReminderPopupVisible(false);
  const closeSendObserverPopup = () => setIsSendObserverPopupVisible(false);

  const openRestartSessionPopup = () => setIsRestartSessionPopupVisible(true);
  const closeRestartSessionPopup = () => setIsRestartSessionPopupVisible(false);
  const openDeleteDocPopup = () => setIsDeleteDocPopupVisible(true);
  const closeDeleteDocPopup = () => setIsDeleteDocPopupVisible(false);

  const openDisableAudioVideoSessionPopup = () =>
    setIsDisableAudioVideoSessionPopupVisible(true);
  const closeDisableAudioVideoSessionPopup = () =>
    setIsDisableAudioVideoSessionPopupVisible(false);

  const handleChangeAction = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      if (newValue !== null) {
      }
    },
    []
  );

  const handleChangeCompletedAction = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      if (newValue !== null) {
      }
    },
    []
  );

  const handleChangeNotaryOwner = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      const selectedOfficial = officials.find(
        (official) => official.name === newValue?.value
      );

      if (
        selectedOfficial &&
        selectedOfficial.name !== session?.official?.name
      ) {
        setSelectedNotaryOwner({
          value: selectedOfficial.name,
          label: selectedOfficial.name,
        });
        if (selectedOfficial?.commissionExpirationDate) {
          const date = new Date(
            selectedOfficial?.commissionExpirationDate?._seconds * 1000
          );
          const formattedDate = date.toString();
          selectedOfficial["commissionExpirationDate"] = formattedDate;
        }
        setUpdatedNotaryOwner(selectedOfficial);
        setIsNotaryOwnerEditable(true);
      } else {
        setIsNotaryOwnerEditable(false);
      }
    },
    [officials, session]
  );

  const handleNotaryOwnerSave = async () => {
    const updateData: any = {};
    if (updatedNotaryOwner) {
      updateData.official = { ...updatedNotaryOwner };
      await handleUpdateDetails(updateData, "notaryOwner");
    } else if (updatedDocumentSeal !== null) {
      updateData.documentsCount = updatedDocumentSeal;
      await handleUpdateDetails(updateData, "documentSeal");
    }
    try {
      handleSessionSelect({
        ...session,
        ...updateData,
      });
      setIsNotaryOwnerEditable(false);
      setIsDocumentSealEditable(false);
      setUpdatedNotaryOwner(null);
      setUpdatedDocumentSeal(null);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const handleNotaryOwnerCancel = () => {
    setIsNotaryOwnerEditable(false);
    setIsDocumentSealEditable(false);
    setUpdatedNotaryOwner(null);
    setSelectedNotaryOwner({
      value: session?.official?.name,
      label: session?.official?.name,
    });
  };

  const openAddDocPopup = () => {
    setIsAddDocPopupOpen(true);
  };

  const closeAddDocPopup = () => {
    setIsAddDocPopupOpen(false);
  };

  const getDocumentFileUrl = (doc: any) => doc?.fileSealed || doc?.file;

  const getDocumentSelectionId = (doc: any) =>
    doc?.id || doc?.key || doc?.documentId || "";

  const buildIframeUrl = (fileUrl?: string | null, docId?: string) => {
    if (!fileUrl) return "";
    const securityParams = generateSecurityCredentials(session?.security);
    const safeDocId = docId || documentId;
    const docParam = safeDocId ? `&docId=${encodeURIComponent(safeDocId)}` : "";
    return `${notaryLink}?${securityParams}${docParam}#/document/${encodeURIComponent(
      fileUrl
    )}`;
  };

  const fetchDocument = async ({ id }: any) => {
    try {
      const getDocumentResponse = await dispatch(
        getDocument({ sessionId: id })
      );

      if (getDocumentResponse.meta.requestStatus == API_STATUS.fulfilled) {
        const docs = [...getDocumentResponse?.payload];
        setDocuments(docs);
        const firstDoc = docs[0];
        setDocumentId(getDocumentSelectionId(firstDoc));
        return getDocumentFileUrl(firstDoc);
      }
      if (getDocumentResponse.meta.requestStatus == "rejected") {
        toast.error("Something went wrong", {
          autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false,
          icon: () => null,
        });
      }
    } catch (error) {
      console.error("error in get session api", error);
    }
  };

  const handleDateEditClick = () => {
    if (session) setIsDateEditable(true);
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      setTempDate(date);
      setSelectedDate(date);
    }
  };

  const handleSaveDate = async () => {
    try {
      await handleUpdateDetails(
        { scheduledAt: moment(tempDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ") },
        "scheduling"
      );
      const date = new Date(
        moment(tempDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
      );
      const scheduledAt = {
        _seconds: Math.floor(date.getTime() / 1000),
        _nanoseconds: date.getMilliseconds() * 1e6,
      };
      handleSessionSelect({
        ...session,
        scheduledAt,
      });
      setSessionDate(moment(tempDate).toDate());
      setSelectedDate(moment(tempDate).toDate());
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const handleCancelDateEdit = () => {
    setTempDate(sessionDate);
    setIsDateEditable(false);
  };

  const validatePhoneNumber = (phone: string) => {
    const phoneRegex = /^[0-9]{10}$/;

    return true;
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [textareaValue]);

  useEffect(() => {
    (async () => {
      const permissions = getFromLocalStorage("permissions");
      const isAvailable = permissions?.includes("notaryScheduling") ?? false;
      setIsAdmin(isAvailable);
      if (session?.id) {
        setTextareaValue(session?.officialPrivateNotes || "");
        setDeleteDocId(null);
        setSessionName(session?.name || "");
        setSessionRecords([]);
        setIsDateEditable(false);
        setIsDocumentSealEditable(false);
        setIsNameEditable(false);
        setIsNotaryOwnerEditable(false);
        setIsNoteEditable(false);
        setIsSessionStageEditable(false);
        setIsSessionDetailsEditable(false);
        setIsSignerDetailEditable(false);
        const fileUrl = await fetchDocument(session);
        console.log('documents', documents[0])
        const iframeUrlTemp = buildIframeUrl(fileUrl, documents[0]?.key);
        if (iframeUrlTemp) setIframeUrl(iframeUrlTemp);
        const getOfficialsResponse = await dispatch(getOfficials({}));
        if (getOfficialsResponse.meta.requestStatus === "fulfilled") {
          setOfficials([...getOfficialsResponse.payload]);
        }
        if (getOfficialsResponse.meta.requestStatus == "rejected") {
          toast.error("Something went wrong", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />, closeOnClick: false,
            icon: () => null,
          });
        }
      }
    })();
  }, [session?.id]);

  useEffect(() => {
    if (session) {
      const completedDate = session?.finishedAt?._seconds
        ? moment(session.finishedAt._seconds * 1000)
          .toDate()
        : null;
      setCompletedSessionDate(completedDate);
      if (!isNameEditable) setSessionName(session?.name);
      if (!isSignerDetailEditable) {
        setSignerDetail({
          ...signerDetail,
          payerEmail: session?.payerEmail || "",
          userEmail: session?.userEmail || session?.user?.email,
          signerName: session?.user?.fullName || "",
          copyRecipient1: session?.emailCopies?.[0] || "",
          copyRecipient2: session?.emailCopies?.[1] || "",
          sessionType: session?.appointmentType || "",
          userPhone: session?.userPhone || "",
          userTimezone: session?.userTimezone || "",
        });
      }
      if (!isDateEditable) {
        const initialDate = session?.scheduledAt?._seconds
          ? moment(session.scheduledAt._seconds * 1000).toDate()
          : null;
        setSessionDate(initialDate);
        setSelectedDate(initialDate);
      }

      if (!isSessionStageEditable) {
        setSelectedSessionStage({
          value: session?.stage,
          label: session?.stage,
        });
      }
      if (!isDocumentSealEditable && !isAddDocPopupOpen)
        setSelectedDocumentSeal(session?.documentsCount);
      if (!isNotaryOwnerEditable)
        setSelectedNotaryOwner({
          label: session?.official?.name,
          value: session?.official?.name,
        });
      const roles = getFromLocalStorage("roles");
      if (roles?.includes("notaryAdmin")) {
        setIsNotaryAdmin(true);
      } else {
        setIsNotaryAdmin(false);
      }
    }
  }, [session]);

  useEffect(() => {
    if (isDateEditable) {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          datePickerRef.current &&
          !datePickerRef.current.contains(event.target as Node)
        ) {
          setIsDateEditable(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isDateEditable]);

  const onJoin = (session: any, path?: any) => {
    if (!session?.security) {
      console.error("No security credentials provided!");
      return false;
    }

    var link = createOfficialLink(notaryLink, session.security);
    if (path) {
      link += path;
    }

    window.open(link, "newwindow", "width=1200,height=1100");
  };

  const onResendDownloadPageLink = async () => {
    try {
      if (session?.stage === "paymentByPayer"  && session?.official?.paymentMode === "licensed_payment") {
       await handleUpdateDetails(
          { stage: 'userSessionEnded', linkSentAt: new Date() },
          "sessionStageCompleted"
        );

        handleSessionSelect({
          ...session,
          stage: 'userSessionEnded',
        });
        setUpdatedStage(null);
        setIsSessionStageEditable(false);
      }
    } catch (e) {
      console.warn('Unable to set session as completed')
    }
    const notificationResponse = await dispatch(
      sendNotification({
        status: COMPLETED_STATUS,
        sessionId: session?.id,
      })
    );

    if (notificationResponse.meta.requestStatus === "fulfilled") {
      toast.success("Download page link sent", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };

  const onCopyDownloadPageLink = () => {
    const notaryLink = process.env.REACT_APP_NOTARY_URL;
    const link = createUserLinkForCopyDownloadPageLink(
      notaryLink,
      session?.security
    );
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.info("Link copied to clipboard", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      })
      .catch(() => {
        toast.error("Failed to copy download page link.", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      });
  };

  const onCopyReceiptLink = () => {
    const link = session.receiptUrl;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.info("Receipt link copied to clipboard!", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      })
      .catch(() => {
        toast.error("Failed to copy receipt link.", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      });
  };

  const onDownloadAllDocuments = async () => {
    await handleDownloadDocuments(documents);
  };

  const onSendSessionFeedback = () => {
    openSessionFeedback();
  };

  const onResendPaymentLink = async () => {
    const sendPaymentEmailResponse = await dispatch(
      sendPaymentEmail({
        token: session.security.token,
        sessionId: session?.id
      })
    );

    if (sendPaymentEmailResponse.meta.requestStatus === "fulfilled") {
      toast.success("Send Payment Email Response", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };

  const onCopyPaymentLink = async () => {
    const link = createUserPaymentLink(notaryLink, session?.security);
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.info("Payment link copied", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      })
      .catch(() => {
        toast.error("Failed to copy session invite link.", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
          style: {
            backgroundColor: "#323232",
            color: "#fff",
            padding: "25px",
            borderRadius: "6px",
          }
        });
      });
  };

  const changeStage = async (stageInParams: string) => {
    let stage = stageInParams || session.stage;
    try {
      if (!stage || stage === session.stage) {
        return;
      }
      if (
        [
          "idVerificationStart",
          "idVerificationFront",
          "mobileVerificationIdCapture",
        ].includes(stage)
      ) {
        await handleUpdateDetails(
          {
            sessionId: session.id,
            latestSubStage: "documentCapture",
            stage: stage,
            idFrontImage: null,
          },
          "upateDoc_id"
        );

        handleSessionSelect({
          ...session,
          sessionId: session.id,
          latestSubStage: "documentCapture",
          stage: stage,
          idFrontImage: null,
        });
      } else {
        await handleUpdateDetails(
          {
            stage: stage,
          },
          "upateDoc"
        );

        handleSessionSelect({
          ...session,
          stage: stage,
        });
        toast.success("Session stage has been changed to " + stage, {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      }
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const onCancel = async (session: any) => {
    try {
      setIsCancelSessionLoading(true);
      await handleUpdateDetails(
        {
          stage: CANCELLED_STATUS,
        },
        "cancel"
      );

      handleSessionSelect({
        ...session,
        stage: CANCELLED_STATUS,
      });
      const notificationResponse = await dispatch(
        sendNotification({
          status: CANCELLED_STATUS,
          sessionId: session?.id,
          note: cancelSessionNote,
        })
      );
      if (notificationResponse.meta.requestStatus == "fulfilled") {

        toast.success("Session canceled", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      }
      if (notificationResponse.meta.requestStatus == "rejected") {
        toast.error("Something went wrong", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      }
    } catch (err: any) {
      console.log("error", err);
    } finally {
      setIsCancelSessionLoading(false);
      closeCancelSessionPopup();
    }
  };

  const onRestart = async (session: any) => {
    try {
      setIsRestartSessionLoading(true);
      await handleUpdateDetails(
        {
          stage: START_STATUS,
          sessionId: session?.id,
          idImageFront: null,
          selfieImage: null,
          idCaptureError: null,
          latestSubStage: "documentCapture",
          eventLog: null,
          idParts: null,
          documentType: null,
        },
        "restart"
      );

      handleSessionSelect({
        ...session,
        stage: START_STATUS,
        sessionId: session?.id,
        idImageFront: null,
        selfieImage: null,
        idCaptureError: null,
        latestSubStage: "documentCapture",
        eventLog: null,
        idParts: null,
        documentType: null,
      });

      setIsRestartSessionLoading(false);
      closeRestartSessionPopup();
      toast.success("Session restarted", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    } catch (err: any) {
      console.log("err", err);
    } finally {
      setIsRestartSessionLoading(false);
      closeRestartSessionPopup();
    }
  };

  const onEnableDisable = async (session: any) => {
    try {
      setIsEnableDisableSessionLoading(true);
      const isDisabled = !(
        session?.settings && session?.settings?.isMeetingDisabled
      );
      await handleUpdateDetails(
        {
          settings: {
            isMeetingDisabled: isDisabled,
          },
        },
        "settings"
      );

      handleSessionSelect({
        ...session,
        settings: {
          isMeetingDisabled: isDisabled,
        },
      });
      setIsEnableDisableSessionLoading(false);
      closeDisableAudioVideoSessionPopup();
      toast.success(`Audio/Video ${isDisabled ? "disabled" : "enabled"}`, {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    } catch (err: any) {
      console.log("err", err);
    }
    finally {
      setIsEnableDisableSessionLoading(false);
      closeDisableAudioVideoSessionPopup();
    }
  };

  const callAction = useCallback(
    async (action: string) => {
      if (action == "joinSession") {
        onJoin(session);
      }
      if (action == "cancelSession") {
        openCancelSessionPopup();
      }
      if (action == "restartSession") {
        openRestartSessionPopup();
      }
      if (action == "disableVideoAudio") {
        openDisableAudioVideoSessionPopup();
      }
      if (action == "copySession") {
        await copySession();
      }
      if (action == "resendSessionLink") {
        await openResendSessionLinkPopup();
      }
      if (action == "sendReminder") {
        await openSendReminderPopup();
      }
      if (action == "sendObserverLink") {
        await openSendObserverPopup();
      }
    },
    [session]
  );

  const callCompletedAction = useCallback(
    (action: string) => {
      if (action == "resendDownloadPageLink") {
        onResendDownloadPageLink();
      }
      if (action == "copyDownloadLink") {
        onCopyDownloadPageLink();
      }
      if (action == "copyReceiptLink") {
        onCopyReceiptLink();
      }
      if (action == "downloadAllDocuments") {
        onDownloadAllDocuments();
      }
      if (action == "sendSessionFeedback") {
        onSendSessionFeedback();
      }
      if (action == "resendPaymentLink") {
        onResendPaymentLink();
      }
      if (action == "copyPaymentLink") {
        onCopyPaymentLink();
      }
    },
    [session]
  );

  const copySession = async () => {
    const notaryLink = process.env.REACT_APP_NOTARY_URL;
    const link = createUserLinkForCopySessionInvite(
      notaryLink,
      session?.security
    );
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.info("Session link copied", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      })
      .catch(() => {
        toast.error("Failed to copy session invite link.", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      });
  };

  const resendSessionLink = async () => {
    setIsResendSessionLinkLoading(true)
    const notificationResponse = await dispatch(
      sendNotification({
        status: "created",
        sessionId: session?.id,
      })
    );

    if (notificationResponse.meta.requestStatus === "fulfilled") {
      toast.success("Session link resent", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
    setIsResendSessionLinkLoading(false);
    closeResendSessionLinkPopup();

  };

  const handleUndo = async (previousData: any, type: string) => {
    const updateSessionDetailResponse = await dispatch(
      updateSessionDetail({
        details: {
          ...previousData,
        },
        sessionId: session?.id,
      })
    );
    if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      if (type == "notes") setTextareaValue(previousData?.officialPrivateNotes);
      if (type == "documentSeal")
        setSelectedDocumentSeal(previousData?.documentsCount);
      if (type == "scheduling") {
        const date = new Date(session?.scheduledAt);
        const scheduledAt = {
          _seconds: Math.floor(date.getTime() / 1000),
          _nanoseconds: date.getMilliseconds() * 1e6,
        };
        previousData = {
          scheduledAt: session?.scheduledAt,
        };
      }

      handleSessionSelect({
        ...session,
        ...previousData,
      });
      toast.success("Changes have been undone", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
    if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      toast.error("Something went wrong", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };
  const handleUpdateDetails = async (data: any, type: string) => {
    let previousState = {};

    if (type == "notes") {
      previousState = {
        officialPrivateNotes: session?.officialPrivateNotes,
      };
    }
    if (type == "sessionStage" || type == "sessionStageCompleted") {
      previousState = {
        stage: session?.stage,
      };
    }

    if (type == "signerDetail") {
      let previousDetail = {};
      if (session?.payerEmail) {
        previousDetail = {
          ...previousDetail,
          payerEmail: session?.payerEmail,
        };
      }
      if (session?.emailCopies.length > 0) {
        previousDetail = {
          ...previousDetail,
          emailCopies: [...session?.emailCopies],
        };
      }
      if (session?.userTimezone) {
        previousDetail = {
          ...previousDetail,
          userTimezone: session?.userTimezone,
        };
      }
      if (session?.appointmentType) {
        previousDetail = {
          ...previousDetail,
          appointmentType: session?.appointmentType,
        };
      }
      if (session?.userPhone) {
        previousDetail = {
          ...previousDetail,
          userPhone: session?.userPhone,
        };
      }
      if (session?.user?.fullName) {
        previousDetail = {
          ...previousDetail,
          signerName: session?.user?.fullName,
        };
      }
      previousState = {
        ...previousDetail,
        multipleSigner: session?.multipleSigner === "Multiple Signers",
      };
    }
    if (type == "notaryOwner") {
      const date = new Date(
        session?.official?.commissionExpirationDate?._seconds * 1000
      );
      const formattedDate = date.toString();
      previousState = {
        official: {
          ...session?.official,
          commissionExpirationDate: formattedDate,
        },
      };
    }
    if (type == "documentSeal") {
      previousState = {
        documentsCount: session?.documentsCount,
      };
    }
    if (type == "cancel") {
      previousState = {
        stage: session?.stage,
      };
    }
    if (type == "sessionName") {
      previousState = {
        name: session?.name,
      };
    }
    if (type == "restart") {
      previousState = {
        stage: session?.stage,
        sessionId: session?.id,
        idImageFront: session?.idImageFront,
        selfieImage: session?.selfieImage,
        idCaptureError: session?.idCaptureError,
        latestSubStage: session?.latestSubStage,
        eventLog: session?.eventLog,
        idParts: session?.idParts,
        documentType: session?.documentType,
      };
    }
    if (type == "scheduling") {
      const date = new Date(session?.scheduledAt?._seconds * 1000);
      previousState = {
        scheduledAt: moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      };
    }
    if (type == "settings") {
      previousState = {
        settings: {
          isMeetingDisabled: session?.isMeetingDisabled,
        },
      };
    }

    const updateSessionDetailResponse = await dispatch(
      updateSessionDetail({
        details: {
          ...data,
        },
        sessionId: session?.id,
      })
    );
    if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      setIsNoteEditable(false);
      setIsSessionStageEditable(false);
      setIsNameEditable(false);
      setIsDateEditable(false);
      setIsSessionDetailsEditable(false);
      if (
        type !== "upateDoc" &&
        type !== "upateDoc_id" &&
        type !== "restart" &&
        type != "cancel" &&
        type != "settings" &&
        type != "documentsCount" &&
        type != "sessionStageCompleted"
      ) {
        toast.success(
          `${type === "sessionFeedback"
            ? "Feedback has been sent"
            : type === "notes"
              ? "Note saved"
              : type === "notaryOwner"
                ? "New notary assigned"
                : type === "documentSeal"
                  ? "Documents/seals updated"
                  : type === "sessionStage"
                    ? "Stage updated"
                    : type === "scheduling"
                      ? "Session rescheduled"
                      : "Details have been updated"
          }`,
          {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          }
        );
      }
    }
    if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      toast.error("Something went wrong", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
      throw new Error("Something went wrong");
    }
  };

  const handleTextareaFocus = () => {
    setIsNoteEditable(true);
  };

  const handleTextareaBlur = () => {
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextareaValue(e.target.value);
  };

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleCancelClick = () => {
    setIsSessionStageEditable(false);
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSessionDetailsSave = async () => {
    try {
      const updateData: any = {};

      if (updatedStage) {
        updateData.stage = updatedStage.value;
      }
      await handleUpdateDetails(updateData, "sessionDetail");
      handleSessionSelect({
        ...session,
        ...updateData,
      });
      setIsSessionDetailsEditable(false);
      setUpdatedStage(null);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  const handleSessionDetailsCancel = () => {
    setIsSessionDetailsEditable(false);
    setUpdatedStage(null);
    setUpdatedDocumentSeal(null);
    setSelectedSessionStage(session?.stage);
    setSelectedDocumentSeal(session?.documentsCount);
  };
  const openPersona = () => {
    if (!personaClientRef.current) {
      personaClientRef.current = new window.Persona.Client({
        templateVersionId: "itmplv_xNwDUt1e1HdenVNjV9d517kk3akB",
        referenceId: session.id,
        environmentId: "env_x1dkEzeHTUvG8Vh9rdEjTSpdSnkE",
        onComplete: ({ inquiryId, status, fields }: any) => {
          if (status === "completed") {
            completeVerification(fields);
          } else if (status === "failed") {
            const errorMessage = "ID Verification Failed";
            toast.error(errorMessage, {
              autoClose: 3000,
              closeButton: <CustomCloseButton />,
              closeOnClick: false,
              icon: () => null,
            });
          }
        },
        onCancel: ({ inquiryId }: any) => {
          rejectVerification(inquiryId);
          const errorMessage = "ID Verification Failed";

          toast.error(errorMessage, {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
          if (personaClientRef.current) {
            personaClientRef.current.destroy();
            personaClientRef.current = null;
          }
        },

        onError: (error: any) => {
          console.log("error===>", error)
        },
      });

      personaClientRef.current.open();
    } else {
      personaClientRef.current.open();
    }
  };

  const completeVerification = async (fields: any) => {
    const documentId = fields["current-government-id"].value.id;
    var zipCode = fields["address-postal-code"].value;

    var address1 = fields["address-street-1"].value;
    var state = fields["address-subdivision"].value;
    var city = fields["address-city"].value;
    var dob = fields["birthdate"].value;
    var dl = fields["identification-number"].value;
    var idExpiration = fields["expiration-date"].value;
    var firstName = fields["name-first"].value;
    var lastName = fields["name-last"].value;
    var documentType = `${fields["selected-country-code"].value} ${fields[
      "identification-class"
    ].value.toUpperCase()}`;
    const updateData: {
      sessionId: any;
      userInfo: {
        zipCode: any;
        address1: any;
        city: any;
        state: any;
        dob: any;
        dl: any;
        firstName: any;
        lastName: any;
        documentType: string;
        idExpiration: any;
      };
      stage: string;
      idFrontImage?: string;
      latestSubStage?: string;
    } = {
      sessionId: session.id,
      userInfo: {
        zipCode: zipCode,
        address1: address1,
        city: city,
        state: state,
        dob: dob,
        dl: dl,
        firstName: firstName,
        lastName: lastName,
        documentType: documentType,
        idExpiration: idExpiration,
      },
      stage: session.isPersonallyKnown
        ? "mobileVerificationPersonalDetails"
        : "personalDetails",
    };
    var targetMarkets = [
      "Missouri",
      "Florida",
      "Montana",
      "LOUISIANA",
      "MINNESOTA",
      "PENNSYLVANIA",
      "NEWYORK_BIOMETRIC",
    ].map(function (m) {
      return m.toLowerCase();
    });
    let firmId = getFromLocalStorage("firmId");
    let officialId = getFromLocalStorage("officialId");
    const options = {
      method: "GET",
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Accept-Encoding': 'gzip, deflate, br, zstd',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'cross-site',
        "X-Firm-Id": firmId,
        "X-Official-Id": officialId,
        "X-Session-Id": session?.id,
      },
    };

    fetch(`${API_URL}/persona/document/${documentId}`, options)
      .then((response) => response.json())
      .then(async (response) => {
        await fetch(
          response.data.attributes['front-photo'].url
        ).then(async (response) => {
          const imageBuffer = await response.arrayBuffer();

          const data = btoa(
            new Uint8Array(imageBuffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          const result = removeBase64Header(
            await resizeSignature(`data:image/png;base64,${data}`, {
              width: 1024,
              height: 1024,
              format: "image/jpeg",
              quality: 0.7,
            })
          );
          updateData.idFrontImage = result;
          // if (
          //   session.official &&
          //   session.official.market &&
          //   targetMarkets.includes(session.official.market.toLowerCase())
          // ) {
          //   updateData.latestSubStage = "selfieCapture";
          //   updateData.stage = "idVerificationFront";
          // }
          if (personaClientRef.current) {
            personaClientRef.current.destroy();
            personaClientRef.current = null;
          }
          const updateSessionDetailResponse = await dispatch(
            updateSessionDetail({
              details: {
                ...updateData,
              },
              sessionId: session?.id,
            })
          );
          if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
            return updateSessionDetailResponse.payload;
          }
          if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
            toast.error("Something went wrong", {
              autoClose: 3000,
              closeButton: <CustomCloseButton />,
              closeOnClick: false,
              icon: () => null,
            });
          }
        });
      });
  };

  const rejectVerification = async (inquiryId: any) => {
    await dispatch(
      updateSessionDetail({
        details: {
          inquiryId
        },
        sessionId: session?.id,
      })
    );
  }

  const openPersonaDashboard = async (inquiryId: any) => {
    const url = `https://app.withpersona.com/dashboard/inquiries/${inquiryId}`;
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  };

  const handleNotesCancel = () => {
    setTextareaValue(session?.officialPrivateNotes || "");
    adjustTextareaHeight();
    setIsNoteEditable(false);
  };

  const handleNotesSave = async () => {
    try {
      setIsNotesLoading(true);
      await handleUpdateDetails(
        { officialPrivateNotes: textareaValue },
        "notes"
      );

      handleSessionSelect({
        ...session,
        officialPrivateNotes: textareaValue,
      });
      setIsNoteEditable(false);
      setIsNotesLoading(false);
      adjustTextareaHeight();
    } catch (err: any) {
      setIsNotesLoading(false);
      console.log("error", err);
    }
  };

  const handleSaveClick = async () => {
    if (updatedStage) {
      try {
        await handleUpdateDetails(
          { stage: updatedStage.value },
          "sessionStage"
        );

        handleSessionSelect({
          ...session,
          stage: updatedStage.value,
        });
        setUpdatedStage(null);
        setIsSessionStageEditable(false);
      } catch (err: any) {
        console.log("error", err);
      }
    }
  };

  const handleDownloadDocuments = async (documents: any) => {
    try {
      await handleDownloadDoc(documents, session.id);
    } catch (err: any) {
      toast.error(err.message, {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };

  const handleBucket = function (session: any) {
    let s3Url = 'https://s3.console.aws.amazon.com/s3/buckets/';
    let s3BucketName = 'prod-onfile-notary-files';

    s3Url += s3BucketName + "?region=us-west-2&prefix=session-files/" + session.id + "/";
    window.open(s3Url, "_blank")
  }

  const handleDocument = async (document: any) => {
    const fileUrl = getDocumentFileUrl(document);
    const iframeUrlTemp = buildIframeUrl(fileUrl, getDocumentSelectionId(document));
    if (!iframeUrlTemp) {
      toast.error("No file URL found for this document.", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
      return;
    }
    setIframeUrl(iframeUrlTemp);
    setDocumentId(getDocumentSelectionId(document));
  };

  const showDocument = (document: any) => {
    const fileUrl = getDocumentFileUrl(document);
    console.log('showDocument', document)
    const docUrl = buildIframeUrl(fileUrl, getDocumentSelectionId(document));
    if (docUrl) setEditIframeUrl(docUrl);
  };

  const updateSessionDetails = async (updatedSession: any, force = false) => {

    if (!updatedSession) return;
    if (force || !updatedSession.documents) {
      const getDocumentResponse = await dispatch(
        getDocument({ sessionId: updatedSession.id })
      );

      if (getDocumentResponse.meta.requestStatus == API_STATUS.fulfilled) {
        const documentIdTemp = getDocumentResponse?.payload;
        if (getDocumentResponse?.payload?.length > 0) {
          showDocument(session?.payload[0]);
        }
      }
      if (getDocumentResponse.meta.requestStatus == "rejected") {
        toast.error("Something went wrong", {
          autoClose: 3000,
          closeButton: <CustomCloseButton />,
          closeOnClick: false,
          icon: () => null,
        });
      }
    }
  };

  const checkSealedFile = useCallback(() => {
    let retries = 0;
    const maxRetries = 10;

    const attemptCheck = async () => {
      if (retries >= maxRetries) {
        console.warn("Max retries reached for checkSealedFile");
        return;
      }

      retries++;

      const checkSessionStatusResponse = await dispatch(
        checkSessionStatus({
          sessionId: session?.id,
        })
      );

      if (checkSessionStatusResponse.meta.requestStatus === "fulfilled") {
        const data = checkSessionStatusResponse.payload;
        if (data && data.sealedUrl) {
          updateSessionDetails({ ...session, ...data }, true);
          return;
        }
      }

      setTimeout(attemptCheck, 5000);
    };

    attemptCheck();
  }, [session]);

  const closeRequestDocPopup = () => {
    setIsRequestDocPopupVisible(false);
  };

  const closeSessionFeedbackPopup = () => {
    setIsSessionFeedbackPopupVisible(false);
  };

  const handleUploadLinkPopupClose = () => {
    setIsUploadLinkPopupOpen(false);
    setIsRequestDocPopupVisible(false);
  };

  const handleUploadLinkPopuOpen = () => {
    setIsUploadLinkPopupOpen(true);
  };

  const handleViewRecord = async () => {
    try {
      const getRecordResponse = await dispatch(
        getRecords({ status: "finished", sessionId: session?.id })
      );
      if (getRecordResponse.meta.requestStatus === API_STATUS.fulfilled) {
        if (getRecordResponse.payload?.length > 0) {
          setSessionRecords(getRecordResponse.payload);
          setIsViewRecordModalOpen(true);
        } else {
          toast.error("No record found", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        }
      }
      if (getRecordResponse.meta.requestStatus === API_STATUS.rejected) {
        console.error("Error fetching records");
      }
    } catch (error) {
      console.error("Error in get records", error);
    } finally {
    }
  };

  const check = useCallback(async () => {
    try {
      const checkSessionStatusResponse = await dispatch(
        checkSessionStatus({
          sessionId: session?.id,
        })
      );
      if (checkSessionStatusResponse.meta.requestStatus === "fulfilled") {
        const data = checkSessionStatusResponse.payload;
        if (!data.updatedAt) return false;
        if (!session.updatedAt) return true;
        if (data.updatedAt._seconds !== session.updatedAt._seconds) return true;

        return false;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking session status:", error);
      return false;
    }
  }, [session]);

  const handleCheck = useCallback(async () => {
    const checkAndReload = async () => {
      const checkResult = await check();
      if (checkResult) {
        window.location.reload();
      } else {
        setTimeout(checkAndReload, 5000);
      }
    };

    checkAndReload();
  }, [check]);

  const handleOpenSession = async (path: string) => {
    if (!session.security) {
      console.error("No security credentials provided!");
      return;
    }

    var link = createOfficialLink(notaryLink, session.security);
    if (path) {
      link += path;
    }

    const newWindow = window.open(link, "newwindow", "width=1200,height=1100");

    checkSealedFile();

    if (!newWindow) {
      console.error("Popup blocked. Enable popups for this site.");
    }
  };


  const editDocument = async (id: string) => {
    await changeStage("customEditDocument");
    await handleCheck();
    await handleOpenSession("/custom-edit-document?document-id=" + id);
  };

  const handleDeleteDoc = async () => {
    if (deleteDocId) {
      setIsDeleteDocLoading(true);
      try {
        const deleteDocumentResponse = await dispatch(
          deleteDocument({ documentId: deleteDocId })
        );
        if (deleteDocumentResponse.meta.requestStatus == API_STATUS.fulfilled) {
          await handleUpdateDetails(
            { documentsCount: selectedDocumentSeal - 1 },
            "documentsCount"
          );
          setSelectedDocumentSeal(prev => prev - 1);

          handleSessionSelect({
            ...session,
            documentsCount: selectedDocumentSeal - 1,
          });
          setDocuments((prev) => prev.filter((doc) => doc.id !== deleteDocId));
          closeDeleteDocPopup();
          toast.success("Document deleted", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        } else {
          toast.error("Error while deleting", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        }
        setIsDeleteDocLoading(false);
      } catch (err: any) {
        setIsDeleteDocLoading(false);
      }
    }
  };
  const addDocument = async (newDocuments: any[]) => {
    const updatedDocuments = [...documents, ...newDocuments];
    setDocuments(updatedDocuments);
    if (updatedDocuments?.length > 0) {
      const firstDoc = updatedDocuments[0];
      const iframeUrlTemp = buildIframeUrl(getDocumentFileUrl(firstDoc), getDocumentSelectionId(firstDoc));
      if (iframeUrlTemp) setIframeUrl(iframeUrlTemp);
      setDocumentId(getDocumentSelectionId(firstDoc));
    }
    await handleUpdateDetails(
      { documentsCount: selectedDocumentSeal },
      "documentsCount"
    );

    handleSessionSelect({
      ...session,
      documentsCount: selectedDocumentSeal,
    });

  };

  const handleDownload = async () => {
    const base64String = session?.idFrontImage;

    if (!base64String) {
      console.error("No valid image found.");
      return;
    }

    if (base64String.includes("https")) {
      try {
        const response = await fetch(base64String);
        if (!response.ok) throw new Error("Failed to fetch the image.");

        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "id-front-image.jpg";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Failed to download image from URL:", error);
      }
      return;
    }

    try {
      const base64Data = base64String.includes("data:image/")
        ? base64String.split(",")[1]
        : base64String;

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Uint8Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteNumbers], { type: "image/png" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "id-front-image.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Failed to decode base64 string or download the image:", error);
    }
  };

  const sendReminder = async ({ includeCopyRecipient, includePayer, message }: any) => {
    try {
      setIsSendReminderLoading(true);

      // Build email recipients
      const toEmail = session?.user?.email; // your main recipient (signer)
      const ccList = [];

      if (includeCopyRecipient && session?.emailCopies?.[0]) ccList.push(session?.emailCopies?.[0]);
      if (includePayer && session?.payerEmail) ccList.push(session?.payerEmail);

      // Construct subject and body
      const subject = `Your Online Notary Session Has Started`;
      const body = message.replace(/\n/g, '<br>');

      // Payload structure for Zapier
      const payload = {
        to: toEmail,
        cc: ccList.join(", "),
        subject,
        body,
        metadata: {
          includeCopyRecipient,
          includePayer,
          sentAt: new Date().toISOString(),
        },
      };

      // Fire webhook
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/hooks/sendReminders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Zapier webhook error:", errText);
        toast.error("Failed to send reminder.");
      } else {
        const reminderInfo  = {
          sentAt: new Date().toISOString(),
          includePayer,
          includeCopyRecipient,
        }
        await dispatch(
          updateSessionDetail({
            details: {
              reminderInfo
            },
            sessionId: session?.id,
          })
        );
        toast.success("Reminder sent successfully!");
        closeSendReminderPopup();
      }
    } catch (error) {
      console.error("Error sending reminder:", error);
      toast.error("Error sending reminder.");
    } finally {
      setIsSendReminderLoading(false);
    }
  };

  const getObserverInviteDefaultMessage = () => {
    const signerName = session?.user?.fullName || "Signer"
    const observerLink = createObserverLinkForSessionInvite(notaryLink, session?.security)
    const signerTimezone = session?.userTimezone || session?.signerTimezone || "UTC"
    const sessionStart = sessionDate
      ? new Intl.DateTimeFormat("en-US", {
          timeZone: signerTimezone,
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit"
        }).format(sessionDate)
      : "TBD"

    return `Hello,

You have been invited to observe an upcoming online notary session for ${signerName}.

Please join using the link below at the scheduled start time:

${observerLink}

Session Start Time:

${sessionStart} (${signerTimezone})

For the best experience, we recommend accessing the session using your mobile device through a web browser, although a desktop or laptop browser will also work.

Please note:

- You will be able to observe the session only.
- You will not be able to interact with the document or complete identity verification.
- You may be required to wait to enter the room until the principal signer has joined the room and their identification has been fully verified.

If you have any questions, please contact our support team at support@onlinenotary.us.

OnlineNotary.us
http://onlinenotary.us/`
  }

  const sendObserverLink = async () => {
    const toEmail = (observerEmail || "").trim();

    if (!toEmail) {
      toast.error("Observer email is required.");
      return;
    }

    try {
      setIsSendObserverLoading(true);

      const payload = {
        to: toEmail,
        cc: "",
        subject: `Observer Invitation - ${session?.user?.fullName || "Online Notary Session"}`,
        body: observerMessage.replace(/\n/g, "<br>"),
        metadata: {
          sentAt: new Date().toISOString(),
          type: "observerInvite"
        }
      };

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/hooks/sendReminders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Observer invite webhook error:", errText);
        toast.error("Failed to send observer link.");
        return;
      }

      const observerInfo = {
        email: toEmail,
        invitedAt: new Date().toISOString()
      };

      const updateSessionResponse = await dispatch(
        updateSessionDetail({
          details: { observerInfo },
          sessionId: session?.id,
        })
      );

      if (updateSessionResponse.meta.requestStatus === "fulfilled") {
        handleSessionSelect({
          ...session,
          observerInfo,
        });
      }

      toast.success("Observer link sent successfully!");
      closeSendObserverPopup();
    } catch (error) {
      console.error("Error sending observer link:", error);
      toast.error("Error sending observer link.");
    } finally {
      setIsSendObserverLoading(false);
    }
  };

  return (
    <Container>
      <NotaryActionBox>
        <FirstColumn>
          <NameContainer>
            <NameAndType>
              {(activeScheduleTab == "scheduled" && !completedSessionDate) ? (
                <NameEditContainer>
                  {isNameEditable ? (
                    <NameInput
                      value={sessionName}
                      onChange={handleNameChange}
                    />
                  ) : (
                    <Name>{session?.name}</Name>
                  )}
                  {!isNameEditable && (
                    <NameEditIcon onClick={handleNameEditClick} />
                  )}
                </NameEditContainer>
              ) : (
                <NameBox>
                  <Name>{session?.name}</Name>
                  {completedSessionDate && (
                    <CompletedSchedule>
                      <Completed>Completed: </Completed>
                      <CompletedTime>
                        {moment(completedSessionDate).format(
                          "MMMM D, YYYY h:mm A"
                        )}
                      </CompletedTime>
                      {session?.linkSentAt && 
                        <>
                          <SentAt>| Link Sent At: </SentAt>
                          <SentAtTime>
                            {moment(session?.linkSentAt).format(
                              "MMMM D, YYYY h:mm A"
                            )}
                          </SentAtTime>
                        </> 
                      }
                    </CompletedSchedule>
                  )}
                </NameBox>
              )}
              {isNameEditable && (
                <ButtonGroupSignerDetail>
                  <Button onClick={handleNameCancel} variant="cancel">
                    Cancel
                  </Button>
                  <Button onClick={handleNameSave} variant="save">
                    {updateLoading ? <LoadingSpinner /> : "Save"}
                  </Button>
                </ButtonGroupSignerDetail>
              )}
              {session?.multipleSigner && (
                <MultipleSignerBox>Multiple signers</MultipleSignerBox>
              )}
            </NameAndType>
            <div style={{display: "flex", alignItems: "center", gap: "8.5px"}}>
              {session?.reminderInfo && <FaBell style={{fontSize:"20px", color: "#EBA43A", marginRight:"20px", cursor: "pointer"}} onClick={() => setIsReminderInfoVisible(true)}/>}
              <SessionActionDropdownBox>
                {activeScheduleTab == "completed" ? (
                  <SessionActionCompletedDropdown
                    onChange={handleChangeCompletedAction}
                    callAction={callCompletedAction}
                    session={session}
                  />
                ) : (
                  <SessionActionDropdown
                    onChange={handleChangeAction}
                    callAction={callAction}
                    session={session}
                  />
                )}
              </SessionActionDropdownBox>
            </div>
          </NameContainer>
        </FirstColumn>
        <SecondColumn>
          <IntroDetail>
            <StyledDate onClick={handleDateEditClick}>
              {moment(sessionDate).format("MMMM D, YYYY h:mm A")}
            </StyledDate>
            {isDateEditable && (
              <DatePickerWrapper ref={datePickerRef}>
                <DatePicker
                  inline
                  selected={selectedDate}
                  onChange={handleDateChange}
                  minDate={new Date()}
                  timeIntervals={30}
                  timeFormat="h:mm aa"
                  timeCaption="Time"
                  showTimeSelect
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
                <ButtonGroupDate>
                  <Button onClick={handleCancelDateEdit} variant="cancel">
                    Cancel
                  </Button>
                  <Button onClick={handleSaveDate} variant="save">
                    {updateLoading ? <LoadingSpinner /> : "Save"}
                  </Button>
                </ButtonGroupDate>
              </DatePickerWrapper>
            )}
            <AppoitmentId onClick={handleCopyAppointmentId}>
              <AppoitmentIdTitle>Appointment ID</AppoitmentIdTitle>
              <AppointmentValue>{session?.appointmentId}</AppointmentValue>
            </AppoitmentId>
          </IntroDetail>

          <NotaryOwnerBox>
            <NotaryTitle>Notary</NotaryTitle>
            <Dropdown
              onChange={handleChangeNotaryOwner}
              value={selectedNotaryOwner}
              options={officials.map((item) => {
                return { value: item.name, label: item.name };
              })}
              isSearchable={true}
            />
          </NotaryOwnerBox>

          <DocumentSealBox>
            <DocumentSealTitle>Documents/seals</DocumentSealTitle>
            <Counter
              value={selectedDocumentSeal || 0}
              onChange={handleDocumentSealChange}
            />
          </DocumentSealBox>
        </SecondColumn>

        {(isNotaryOwnerEditable || isDocumentSealEditable) && (
          <ButtonGroup>
            <Button onClick={handleNotaryOwnerCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleNotaryOwnerSave} variant="save">
              {updateLoading ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroup>
        )}
      </NotaryActionBox>

      <NotesActionBox>
        <NotesSessionStageBox>
          <SubColoumn style={{ flex: "1.2 1 36%" }}>
            <StageColumn>
              <StageColumnName>Stage</StageColumnName>
              <SessionStageBox>
                <Dropdown
                  onChange={handleChangeSessionStage}
                  value={selectedSessionStage}
                  options={SESSION_STAGES}
                  isSearchable={true}
                />
              </SessionStageBox>
            </StageColumn>
            {isSessionStageEditable && (
              <ButtonGroup>
                <Button onClick={handleCancelClick} variant="cancel">
                  Cancel
                </Button>
                <Button onClick={handleSaveClick} variant="save">
                  {updateLoading ? <LoadingSpinner /> : "Save"}
                </Button>
              </ButtonGroup>
            )}
          </SubColoumn>
          <SubColoumn style={{ flex: "1.8 1 64%" }}>
            <NotesSubBox>
              <NotesContentBox>
                <NotesHeader>
                  <NotesTitle>Notes</NotesTitle>
                </NotesHeader>

                <FloatingLabelTextarea
                  ref={textareaRef}
                  label=""
                  value={textareaValue}
                  onChange={handleTextareaChange}
                  onFocus={handleTextareaFocus}
                  onBlur={handleTextareaBlur}
                  readOnly={!isNotesEditable}
                  maxLength={300}
                  rows={1}
                />
              </NotesContentBox>
              <WordCount>
                {textareaValue.length} / {300}
              </WordCount>
            </NotesSubBox>
            {isNotesEditable && (
              <ButtonGroup>
                <Button onClick={handleNotesCancel} variant="cancel">
                  Cancel
                </Button>
                <Button onClick={handleNotesSave} variant="save">
                  {isNotesLoading ? <LoadingSpinner /> : "Save"}
                </Button>
              </ButtonGroup>
            )}
          </SubColoumn>

        </NotesSessionStageBox>
      </NotesActionBox>

      <SignerDetailBox>
        <SignerTitle>
          Signer Details
          {!isSignerDetailEditable && (
            <EditIcon onClick={handleSignerDetailEditClick} />
          )}
        </SignerTitle>
        <Columns>
          {Object.keys(signerDetail).map((key, index) => (
            <Column key={index}>
              <ColumnName
                onClick={() => {
                  if (labelMapping[key] === "Signer email") {
                    navigator.clipboard
                      .writeText(session.appointmentId)
                      .then(() => {
                        toast.info(`${labelMapping[key]} copied`, {
                          autoClose: 3000,
                          closeButton: <CustomCloseButton />,
                          closeOnClick: false,
                          icon: () => null,
                        });
                      })
                      .catch(() => {
                        toast.error(`Failed to copy ${labelMapping[key]}.`, {
                          autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false,
                          icon: () => null,
                        });
                      });
                    navigator.clipboard.writeText((signerDetail as any)[key]);
                  }
                }}
                style={
                  labelMapping[key] === "Signer email"
                    ? { cursor: "pointer" }
                    : {}
                }
              >
                {labelMapping[key] || key.split(/(?=[A-Z])/).join(" ")}
              </ColumnName>
              {isSignerDetailEditable ? (
                key === "sessionType" ? (
                  <Dropdown
                    options={appointmentTypes}
                    value={selectedSessionType}
                    onChange={handleSessionTypeChange}
                  />
                ) :
                  key === "userTimezone" ? (
                    <Dropdown
                      value={{
                        value: (signerDetail as any)[key] || "",
                        label:
                          TIME_ZONES.find(
                            (zone) => zone.value === (signerDetail as any)[key]
                          )?.name || "Select Time Zone",
                      }}
                      onChange={(
                        newValue: SingleValue<OptionType>,
                        actionMeta: ActionMeta<OptionType>
                      ) => {
                        handleSignerDetailChange({
                          target: {
                            name: key,
                            value: newValue?.value || "",
                          },
                        } as React.ChangeEvent<HTMLInputElement>);
                      }}
                      styles={{
                        option: {
                          fontSize: "14px",
                        },
                      }}
                      options={TIME_ZONES.map((zone) => ({
                        value: zone.value,
                        label: zone.name,
                      }))}
                      isSearchable={true}
                    />
                  ) : (
                    <ColumnValue
                      name={key}
                      value={(signerDetail as any)[key]}
                      onChange={handleSignerDetailChange}
                      readOnly={!isSignerDetailEditable}
                    />
                  )
              ) : (
                <ColumnValue
                  isEditable={false}
                  readOnly
                  value={(signerDetail as any)[key]}
                />
              )}
            </Column>
          ))}
        </Columns>
        {isSignerDetailEditable && (
          <ButtonGroupSignerDetail>
            <Button onClick={handleSignerDetailCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleSignerDetailSave} variant="save">
              {updateLoading ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroupSignerDetail>
        )}
      </SignerDetailBox>
      <AppoitmentDetailBox>
        <SignerTitle>Session Details</SignerTitle>
        <AppoitmentColumns>
          <BadgeColumn>
            <BadgeSubColumn>
              <BadgeColumnName>Credential Analysis</BadgeColumnName>
              <Badge status={getCredentialAnalysisStatus(session).text}>
                {getCredentialAnalysisStatus(session).text}
              </Badge>
            </BadgeSubColumn>
          </BadgeColumn>
          <BadgeColumn>
            <BadgeSubColumn>
              <BadgeColumnName>Identify Proofing</BadgeColumnName>
              <Badge status={getQuizStatus(session).text}>
                {getQuizStatus(session).text}
              </Badge>
            </BadgeSubColumn>
          </BadgeColumn>

          {session?.userGeo && (
            <Column>
              <ColumnName>Signer Location</ColumnName>
              <SessionColumnValue>
                {session.userGeo.country +
                  ", " +
                  session.userGeo.city +
                  ", " +
                  session.userGeo.regionName +
                  ", " +
                  session.userGeo.zip}
              </SessionColumnValue>
            </Column>
          )}
          {session?.userGeo?.isp && (
            <Column>
              <ColumnName>Signer Network</ColumnName>
              <SessionColumnValue>{session?.userGeo?.isp}</SessionColumnValue>
            </Column>
          )}

          {getDevice(session) && (
            <Column>
              <ColumnName>Signer Device</ColumnName>
              <SessionColumnValue>{getDevice(session)}</SessionColumnValue>
            </Column>
          )}
        </AppoitmentColumns>

        {isSessionDetailsEditable && (
          <ButtonGroupSignerDetail>
            <Button onClick={handleSessionDetailsCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleSessionDetailsSave} variant="save">
              {updateLoading ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroupSignerDetail>
        )}
      </AppoitmentDetailBox>

      <TabBox>
        <Tabs>
          <Tab
            isActive={activeTab === "Session Documents"}
            onClick={() => setActiveTab("Session Documents")}
          >
            Session Documents
          </Tab>

          <Tab
            isActive={activeTab === "Session Status"}
            onClick={() => setActiveTab("Session Status")}
          >
            Session Status
          </Tab>
          <IconsBox>
            {(isAdmin || isNotaryAdmin) && (
              <img
                src={BucketIcon}
                style={{
                  width: "35px",
                  height: "35px",
                }}
                alt="Bucket Icon"
                onClick={(event: any) => handleBucket(session)}
              />
            )}

            {(activeScheduleTab == "scheduled" && !completedSessionDate) ? (
              <>
                <NewDocumentIcon
                  onClick={() => openAddDocPopup()}
                  style={{
                    width: "30px",
                    height: "30px",
                  }}
                />
                <RequestIcon
                  onClick={handleRequestDoc}
                  style={{
                    width: "30px",
                    height: "30px",
                  }}
                />
              </>
            ) : null}

            <DownloadIcon
              style={{
                width: "30px",
                height: "30px",
              }}
              onClick={(event) => handleDownloadDocuments(documents)}
            />
          </IconsBox>
        </Tabs>
        <TabContent>
          {activeTab == "Session Documents" ? (
            <>
              {iframeUrl && documentId && (
                <>
                  <SessionDocumentsContainer>
                    <IframeHeader>
                      {/* <SessionDocumentHeading>
                        Session document
                      </SessionDocumentHeading> */}
                      {(activeScheduleTab == "scheduled" && !completedSessionDate) ? (
                        <ParticularDoc>
                          {documents.map((document: any, index: number) => {
                            const isEditing = editingDocumentId === document?.document_id;

                            return (
                              <IframeHeaderBox
                                onClick={() => handleDocument(document)}
                                isLast={documents.length === index + 1}
                                key={document?.document_id}
                              >
                                <IframeDocSubBox
                                  isActive={documentId === getDocumentSelectionId(document)}
                                >
                                  {isEditing ? (
                                    <div style={{ display: "flex", marginLeft: "10px" }}>
                                      <input
                                        type="text"
                                        value={editingDocumentName}
                                        onChange={(e) => setEditingDocumentName(e.target.value)}
                                        style={{ width: "100%" }}
                                      />
                                      <EditDocNameButton>
                                        <button
                                          onClick={() => saveDocumentName(document?.id)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {isDocNameLoading ? <LoadingDocName /> : "Save"}
                                        </button>
                                        <button style={{ cursor: "pointer" }}
                                          onClick={cancelEditDocument}>Cancel</button>
                                      </EditDocNameButton>

                                    </div>
                                  ) : (
                                    <DocName>
                                      {document?.name}{" "}
                                      <EditDocName
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          enableEditDocument(document?.document_id, document?.name);
                                        }}
                                      >
                                        Edit Name
                                      </EditDocName>
                                    </DocName>
                                  )}
                                  <EditDeletIconBox>
                                    {!session?.isCompleted && (
                                      <EditIconSvg
                                        style={{
                                          width: "23px",
                                          height: "23px",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          editDocument(document?.id);
                                        }}
                                      />
                                    )}
                                    {!session?.isCompleted && documents?.length > 1 && (
                                      <TrashIcon
                                        style={{
                                          width: "23px",
                                          height: "23px",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openDeleteDocPopup();
                                          setDeleteDocId(document?.id);
                                        }}
                                      />
                                    )}
                                    <DownloadIcon
                                      style={{
                                        width: "23px",
                                        height: "23px",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSingleDocumentDownload(document);
                                      }}
                                    />
                                  </EditDeletIconBox>
                                </IframeDocSubBox>
                              </IframeHeaderBox>
                            );
                          })}
                        </ParticularDoc>
                      ) : (
                        <ParticularDoc>
                          {documents.map((document: any, index: number) => {
                            return (
                              <IframeHeaderContainer>
                                <IframeHeaderBox
                                  onClick={() => handleDocument(document)}
                                  isLast={documents.length === index + 1}
                                >
                                  <IframeDocSubBox
                                    isActive={
                                      documentId === getDocumentSelectionId(document)
                                    }
                                  >
                                    <DocName>{document?.name}</DocName>
                                  </IframeDocSubBox>
                                  <DownloadIconBox>
                                    <DownloadIcon
                                      style={{
                                        width: "23px",
                                        height: "23px",
                                        cursor: "pointer"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSingleDocumentDownload(document);
                                      }}
                                    />
                                  </DownloadIconBox>
                                  <BookIconBox onClick={handleViewRecord}>
                                    <BookIcon
                                      style={{ width: "23px", height: "23px" }}
                                    />
                                  </BookIconBox>
                                </IframeHeaderBox>
                              </IframeHeaderContainer>
                            );
                          })}
                        </ParticularDoc>
                      )}
                    </IframeHeader>
                  </SessionDocumentsContainer>
                  <StyledIframe
                    ng-show="showCanvas"
                    ng-src={iframeUrl}
                    aria-hidden="false"
                    className=""
                    src={iframeUrl}
                  ></StyledIframe>
                </>
              )}
            </>
          ) : (
            <>
              <SessionStatusBox>
                <FirstColumnSessioStatus>
                  <Row>
                    <RowName>Principal:</RowName>
                    <RowText>{session?.user?.fullName || ""}</RowText>
                  </Row>

                  <Row>
                    <RowName>Credential analysis:</RowName>
                    <RowText>
                      {getCredentialAnalysisStatus(session).text}
                    </RowText>
                  </Row>

                  <Row>
                    <RowName>Identity proofing quiz:</RowName>
                    <RowText>{getQuizStatus(session).text}</RowText>
                  </Row>
                  {getDevice(session) && (
                    <Row>
                      <RowName>Principal device:</RowName>
                      <RowText>{getDevice(session)}</RowText>
                    </Row>
                  )}
                  <Gap />
                  <Row>
                    <RowName>Notary in-session?</RowName>
                    {isOfficialOnline ? <OnlineRowSign /> : <OfflineRowSign />}
                    {isOfficialOnline &&
                      session?.officialConnectivity?.level && (
                        <RowText>
                          {session?.officialConnectivity?.level} / 5{" "}
                          <FaSignal />
                        </RowText>
                      )}
                  </Row>

                  <Row>
                    <RowName>Signer in-session?</RowName>
                    {isSignerOnline ? <OnlineRowSign /> : <OfflineRowSign />}
                    {isSignerOnline && session?.signerConnectivity?.level && (
                      <RowText>
                        {session?.signerConnectivity?.level} / 5 <FaSignal />
                      </RowText>
                    )}
                  </Row>

                  <Row>
                    <RowName>Signer video status:</RowName>
                    {(!STAGES_BEFORE_CAMERA_CHECK.includes(session.stage) && session?.userVideoJoined) ? (
                      <OnlineRowSign />
                    ) : (
                      <OfflineRowSign />
                    )}
                    {session?.signerConnectivity &&
                      session?.signerConnectivity?.error && (
                        <RowText>
                          WebRTC Error: {session?.signerConnectivity?.error}
                        </RowText>
                      )}
                  </Row>

                  <Row>
                    <RowName>Session stage:</RowName>
                    <RowText>{session?.stage}</RowText>
                  </Row>
                  <Gap />
                  <Row>
                    <RowName>Signer email:</RowName>
                    <RowText>{session?.user?.email || ""}</RowText>
                  </Row>
                  {session?.userPhone && (
                    <Row>
                      <RowName>Signer phone:</RowName>
                      <RowText>{session?.userPhone || ""}</RowText>
                    </Row>
                  )}
                  {signerDetail?.userTimezone && (
                    <Row>
                      <RowName>Signer timezone:</RowName>
                      <RowText>{signerDetail?.userTimezone}</RowText>
                    </Row>
                  )}
                  <Gap />
                </FirstColumnSessioStatus>
                <SecondColumnSessioStatus>
                  {session?.idFrontImage && (
                    <UploadedImgContainer>
                      <UploadedImage
                        src={
                          session?.idFrontImage?.includes('https')
                            ? session.idFrontImage
                            : `data:image/png;base64,${session.idFrontImage}`
                        } alt="Uploaded"
                      />
                    </UploadedImgContainer>
                  )}
                  <UploadButton>
                    <UploadIdButton onClick={() => openPersona()}>
                      Upload ID
                    </UploadIdButton>
                    {session.idFrontImage && (
                      <UploadIdButton onClick={handleDownload}>
                        Download ID
                      </UploadIdButton>
                    )}
                    {session?.inquiryId && (
                      <PersonaDashboardText onClick={() => openPersonaDashboard(session?.inquiryId)}>
                        Persona Dashboard
                      </PersonaDashboardText>
                    )}

                    <input
                      id="fileInput"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </UploadButton>
                </SecondColumnSessioStatus>
              </SessionStatusBox>
              {iframeUrl && documentId && (
                <StyledIframe
                  ng-show="showCanvas"
                  ng-src={iframeUrl}
                  aria-hidden="false"
                  className=""
                  src={iframeUrl}
                ></StyledIframe>
              )}
            </>
          )}
        </TabContent>
      </TabBox>
      {editIframeUrl && (
        <StyledIframe
          ng-show="showCanvas"
          ng-src={editIframeUrl}
          aria-hidden="false"
          className=""
          src={editIframeUrl}
        ></StyledIframe>
      )}

      {isCancelSessionPopupVisible && (
        <PopupOverlay onClick={closeCancelSessionPopup}>
          <PopupCancelContainer onClick={(e) => e.stopPropagation()}>
            <PopupCancelHeader>Cancel notary session</PopupCancelHeader>
            <InputCancelWrapper>
              <TextareaField
                onFocus={() => setIsCancelSessionInputFocused(true)}
                onBlur={() => setIsCancelSessionInputFocused(false)}
                aria-label="Include note to principal"
                value={cancelSessionNote}
                onChange={(e) => setCancelSessionNote(e.target.value)}
              />
              <InputCancelLabel
                isFocused={
                  isCancelSessionInputFocused || Boolean(session?.note)
                }
              >
                Include note to principal
              </InputCancelLabel>
            </InputCancelWrapper>
            <ButtonCancelCheckBox>
              <CheckboxCancelContainer>
                <input type="checkbox" id="emailCheck" />
                <label htmlFor="emailCheck">Do not email principal</label>
              </CheckboxCancelContainer>
              <ButtonCancelGroup>
                <Button onClick={() => onCancel(session)} variant="save">
                  {isCancelSessionLoading ? (
                    <LoadingSpinner />
                  ) : (
                    "Cancel session"
                  )}
                </Button>
                <Button onClick={closeCancelSessionPopup}>Cancel</Button>
              </ButtonCancelGroup>
            </ButtonCancelCheckBox>
          </PopupCancelContainer>
        </PopupOverlay>
      )}
      {isRestartSessionPopupVisible && (
        <PopupOverlay onClick={closeRestartSessionPopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription>
              Are you sure you want to restart the session ?
            </PopupDescription>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={() => onRestart(session)} variant="save">
                  {isRestartSessionLoading ? <LoadingSpinner /> : "Yes"}
                </Button>
                <Button onClick={closeRestartSessionPopup}>No</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </PopupContainer>
        </PopupOverlay>
      )}
      {isResendSessionLinkPopupVisible && (
        <PopupOverlay onClick={closeResendSessionLinkPopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription>
              Are you sure you want to resend the link ?
            </PopupDescription>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={() => resendSessionLink()} variant="save">
                  {isResendSessionLinkLoading ? <LoadingSpinner /> : "Yes"}
                </Button>
                <Button onClick={closeResendSessionLinkPopup}>No</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </PopupContainer>
        </PopupOverlay>
      )}
      {isDeleteDocPopupVisible && (
        <PopupOverlay onClick={closeRestartSessionPopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription>
              Are you sure you want to delete this document ?
            </PopupDescription>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={() => handleDeleteDoc()} variant="save">
                  {isDeleteDocLoading ? <LoadingSpinner /> : "Yes"}
                </Button>
                <Button onClick={closeDeleteDocPopup}>No</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </PopupContainer>
        </PopupOverlay>
      )}
      {isSendReminderPopupVisible && (
        <PopupOverlay onClick={closeSendReminderPopup}>
          <SendReminderContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription style={{ fontSize: "1.25rem", fontWeight: "600", marginBottom: "1rem" }}>
              Send a reminder
            </PopupDescription>

            <div style={{ marginBottom: "1rem", width: "100%"  }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <input
                  type="checkbox"
                  id="includeCopyRecipient"
                  checked={includeCopyRecipient}
                  onChange={(e) => setIncludeCopyRecipient(e.target.checked)}
                  style={{ marginRight: "0.5rem"}}
                />
                <label htmlFor="includeCopyRecipient">
                  Include copy recipient
                </label>
                {includeCopyRecipient && (
                  <span style={{ marginLeft: "0.5rem", color: "#555" }}>{session?.emailCopies?.[0]}</span>
                )}
              </div>

              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <input
                  type="checkbox"
                  id="includePayer"
                  checked={includePayer}
                  onChange={(e) => setIncludePayer(e.target.checked)}
                  style={{ marginRight: "0.5rem" }}
                />
                <label htmlFor="includePayer">Include payer</label>
                {includePayer && (
                  <span style={{ marginLeft: "0.5rem", color: "#555" }}>{session?.payerEmail}</span>
                )}
              </div>
            </div>

            <div style={{ marginBottom: "1.5rem", width: "80%", marginLeft: "none"}}>
              <textarea
                rows={14}
                style={{
                  width: "100%",
                  resize: "vertical",
                  padding: "10px",
                  fontSize: "0.95rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontFamily: "inherit",
                }}
                value={reminderMessage}
                onChange={(e) => setReminderMessage(e.target.value)}
              />
            </div>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button
                  onClick={() =>
                    sendReminder({
                      includeCopyRecipient,
                      includePayer,
                      message: reminderMessage,
                    })
                  }
                  variant="save"
                >
                  {isSendReminderLoading ? <LoadingSpinner /> : "Send"}
                </Button>
                <Button onClick={closeSendReminderPopup}>Cancel</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </SendReminderContainer>
        </PopupOverlay>
      )}
      {isSendObserverPopupVisible && (
        <PopupOverlay onClick={closeSendObserverPopup}>
          <SendReminderContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription style={{ fontSize: "1.25rem", fontWeight: "600", marginBottom: "1rem" }}>
              Send observer link
            </PopupDescription>

            <div style={{ marginBottom: "1rem", width: "80%" }}>
              <label style={{ display: "block", marginBottom: "0.4rem" }}>
                Observer email
              </label>
              <input
                type="email"
                value={observerEmail}
                onChange={(e) => setObserverEmail(e.target.value)}
                placeholder="observer@email.com"
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "0.95rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontFamily: "inherit",
                }}
              />
            </div>

            <div style={{ marginBottom: "1.5rem", width: "80%" }}>
              <label style={{ display: "block", marginBottom: "0.4rem" }}>
                Email content
              </label>
              <textarea
                rows={16}
                style={{
                  width: "100%",
                  resize: "vertical",
                  padding: "10px",
                  fontSize: "0.95rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontFamily: "inherit",
                }}
                value={observerMessage}
                onChange={(e) => setObserverMessage(e.target.value)}
              />
            </div>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={sendObserverLink} variant="save">
                  {isSendObserverLoading ? <LoadingSpinner /> : "Send"}
                </Button>
                <Button onClick={closeSendObserverPopup}>Cancel</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </SendReminderContainer>
        </PopupOverlay>
      )}
      {isReminderInfoVisible && session?.reminderInfo && (
        <PopupOverlay onClick={() => setIsReminderInfoVisible(false)}>
          <ReminderPopupContainer onClick={(e) => e.stopPropagation()}>
            <div style={{ padding: "10px 0" }}>
              <p>
                <strong>Sent At:</strong>{" "}
                {moment(session?.reminderInfo?.sentAt).format("MMMM D, YYYY h:mm A")}
              </p>
              <p>
                <strong>Sent to Payer:</strong>{" "}
                {session?.reminderInfo?.includePayer ? session?.payerEmail : "No"}
              </p>
              <p>
                <strong>Sent to Copy Recipient:</strong>{" "}
                {session?.reminderInfo?.includeCopyRecipient ? session?.emailCopies?.[0] : "No"}
              </p>
            </div>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={() => setIsReminderInfoVisible(false)}>Close</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </ReminderPopupContainer>
        </PopupOverlay>
      )}
      {isDisableAudioVideoSessionPopupVisible && (
        <PopupOverlay onClick={closeDisableAudioVideoSessionPopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription>
              Are you sure you want to{" "}
              {session?.settings && session?.settings?.isMeetingDisabled
                ? "enable"
                : "disable"}{" "}
              Audio/Video for this session?
            </PopupDescription>

            <ButtonCheckBox>
              <DisableAudioVideoButtonGroup>
                <Button onClick={() => onEnableDisable(session)} variant="save">
                  {isEnableDisableSessionLoading ? <LoadingSpinner /> : "Yes"}
                </Button>
                <Button onClick={closeDisableAudioVideoSessionPopup}>No</Button>
              </DisableAudioVideoButtonGroup>
            </ButtonCheckBox>
          </PopupContainer>
        </PopupOverlay>
      )}

      {isRequestDocPopupVisible && (
        <RequestDocumentPopup
          onClose={closeRequestDocPopup}
          session={session}
          onSuccess={handleUploadLinkPopuOpen}
        />
      )}
      {isSessionFeedbackPopupVisible && (
        <SendFeedbackPopup
          onClose={closeSessionFeedbackPopup}
          onSuccess={handleSessionFeedback}
        />
      )}
      {isUploadLinkPopupOpen && (
        <UploadLinkPopup
          onClose={handleUploadLinkPopupClose}
          session={session}
        />
      )}
      {isViewRecordModalOpen && (
        <AcknowledgmentModal
          open={isViewRecordModalOpen}
          acknowledgments={sessionRecords}
          onClose={() => setIsViewRecordModalOpen(false)}
        />
      )}
      <StepTwoPopup
        open={isAddDocPopupOpen}
        onClose={closeAddDocPopup}
        addDocument={addDocument}
        sessionId={session?.id}
        setSelectedDocumentSeal={setSelectedDocumentSeal}
      />
    </Container>
  );
};

export default SessionSummary;

const Container = styled.div`
  flex: 65.88; /* Reduced by 5% */
  height: fit-content;
  background: #f9f9f9;
  padding: 16.25px; /* Reduced by 5% */
  padding-top: 0px;
  overflow: hidden;
  @media (max-width: 768px) {
    flex: none;
    width: 100%;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  overflow: hidden;
`;

const MultipleSignerBox = styled.span`
  display: flex;
  gap: 8.55px; /* Reduced by 5% */
  height: fit-content;
  background: #f6e5e2;
  padding: 5.985px 8.55px; /* Reduced by 5% */
  color: #ca3016;
  font-size: 95%; /* Reduced by 5% */
`;

const StyledIframe = styled.iframe`
  width: 95%; /* Reduced by 5% */
  height: 102.6vh; /* Reduced by 5% */
  border: none;
  overflow: hidden;
`;

const IconsBox = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  gap: 15.39px; /* Reduced by 5% */
  margin-left: auto;
  align-self: center;
  margin-right: 17.1px; /* Reduced by 5% */
`;

const IframeHeaderBox = styled.div<{ isLast: boolean }>`
  display: flex;
  overflow: hidden; /* Hides scrollbars */
  border-bottom: ${(props) =>
    props.isLast ? "1px solid #ccc" : "1px solid #ccc"};
  padding-bottom: 5.13px; /* Reduced by 5% */
  padding-top: 5.13px; /* Reduced by 5% */
  gap: 8.55px; /* Reduced by 5% */
`;

const IframeHeaderContainer = styled.div``;

const EditDocNameButton = styled.div`
  margin-left: 9.5px; /* Reduced by 5% */
  display: flex;
  cursor: pointer;
  gap: 9.5px; /* Reduced by 5% */
`;

const IframeDocSubBox = styled.div<{ isActive: boolean }>`
  display: flex;
  flex: 1;
  justify-content: space-between;
  overflow: hidden; /* Hides scrollbars */
  padding-top: 8.55px; /* Reduced by 5% */
  padding-bottom: 8.55px; /* Reduced by 5% */
  background: ${(props) => (props.isActive ? "#F1F1F1" : "white")};
  padding: 8.55px; /* Reduced by 5% */
  font-size: 95%; /* Reduced by 5% */
`;

const IframeHeader = styled.div`
  flex: 6.65; /* Reduced by 5% */
`;

const SessionDocumentsContainer = styled.div`
  display: flex;
  gap: 51.3px; /* Reduced by 5% */
`;

const ParticularDoc = styled.div`
  margin-bottom: 25.65px; /* Reduced by 5% */
`;

const DocName = styled.span`
  display: flex;
  font-size: 12.31px; /* Reduced by 5% */
  align-items: center;
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`;

const EditDocName = styled.span`
  display: flex;
  font-size: 10.45px; /* Reduced by 5% */
  align-items: center;
  font-weight: 500;
  margin-left: 9.5px; /* Reduced by 5% */
  cursor: pointer;
  color: grey;
  opacity: 0.8;
`;

const EditDeletIconBox = styled.div`
  display: flex;
  gap: 12.83px; /* Reduced by 5% */
  cursor: pointer;
`;

const BookIconBox = styled.div`
  display: flex;
  gap: 12.83px; /* Reduced by 5% */
  cursor: pointer;
  align-items: center;
`;

const DownloadIconBox = styled.div`
  display: flex;
  gap: 12.83px; /* Reduced by 5% */
  cursor: pointer;
  align-items: center;
`;

const EditIcon = styled(MdOutlineEdit)`
  color: #007bff;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.dark};
  }
`;

const NameEditIcon = styled(MdOutlineEdit)`
  color: #007bff;
  width: 21.38px; /* Reduced by 5% */
  height: 21.38px; /* Reduced by 5% */
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.dark};
  }
`;

const NotaryOwnerBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10.26px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
  flex: 1;
`;

const NotaryTitle = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font-size: 14.54px; /* Reduced by 5% */
`;

const DocumentSealTitle = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font-size: 14.71px; /* Reduced by 5% */
  max-width: 128.25px; /* Reduced by 5% */
`;
const NotaryActionBox = styled.div`
  background: white;
  padding: 17.1px; /* Reduced by 5% */
  padding-bottom: 12.83px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
`;

const FirstColumn = styled.div`
  display: flex;
  margin-bottom: 17.1px; /* Reduced by 5% */
  padding-bottom: 10.26px; /* Reduced by 5% */
  border-bottom: ${(props) => `1.71px solid ${props.theme.colors.normal}`}; /* Reduced by 5% */
`;

const NameContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8.55px; /* Reduced by 5% */
`;

const NameAndType = styled.div`
  display: flex;
  gap: 51.3px; /* Reduced by 5% */
`;

const NameBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: center;
  gap: 8.55px; /* Reduced by 5% */
`;

const CompletedSchedule = styled.div`
  width: 100%;
  display: flex;
  gap: 4.28px; /* Reduced by 5% */
`;
const NameEditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8.55px; /* Reduced by 5% */
`;

const NameInput = styled.input`
  font-size: 18.81px; /* Reduced by 5% */
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 500;
  width: 100%;
`;

const Name = styled.span`
  font-size: 26.93px; /* Reduced by 5% */
  color: black;
  font-weight: 800;
`;

const Completed = styled.span`
  font-size: 12.31px; /* Reduced by 5% */
  color: #3fc163;
  font-weight: 500;
`;

const CompletedTime = styled.span`
  font-size: 12.31px; /* Reduced by 5% */
  color: #3fc163;
  font-weight: 500;
`;

const SentAt = styled.span`
  font-size: 12.31px; /* Reduced by 5% */
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 500;
`;

const SentAtTime = styled.span`
  font-size: 12.31px; /* Reduced by 5% */
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 500;
`;

const SessionActionDropdownBox = styled.div`
  border-radius: 8.55px; /* Reduced by 5% */
  box-shadow: 0px 4.28px 17.1px rgba(58, 58, 58, 0.18); /* Reduced by 5% */
  float: right;
`;

const SecondColumn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 18.81px; /* Reduced by 5% */
  margin-bottom: 1.71px; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 21.38px 25.65px; /* Reduced by 5% */
  }
`;

const IntroDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4.56px; /* Reduced by 5% */
  flex: 1;
  font-size: 14.82px; /* Reduced by 5% */
  font-weight: 500;
  color: black;
`;

const StyledDate = styled.span`
  display: flex;
  cursor: pointer;
`;
const AppoitmentId = styled.span`
  display: flex;
  cursor: pointer;
`;

const AppoitmentIdTitle = styled.span`
  margin-right: 6.84px; /* Reduced by 5% */
`;

const AppointmentValue = styled.span``;

const SignerDetailBox = styled.div`
  padding: 17.1px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: flex;
  flex-direction: column;
  background: white;
  margin-top: 15.39px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
  border-left: 5.99px solid #c1d3f5; /* Reduced by 5% */
`;

const AppoitmentDetailBox = styled(SignerDetailBox)``;

const SignerTitle = styled.h3`
  text-align: left;
  margin-bottom: 17.1px; /* Reduced by 5% */
  font-size: 17.1px; /* Reduced by 5% */
  margin-top: 0px;
  display: flex;
  align-items: center;
  gap: 6.84px; /* Reduced by 5% */
`;

const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 27.36px; /* Reduced by 5% */
  column-gap: 13.68px; /* Reduced by 5% */
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AppoitmentColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  row-gap: 27.36px; /* Reduced by 5% */
  column-gap: 13.68px; /* Reduced by 5% */
  width: 100%;
  @media (max-width: 1200px) {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5.99px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const BadgeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5.99px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const BadgeSubColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5.99px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const StageColumn = styled(Column)`
  background: white;
  padding: 17.1px; /* Reduced by 5% */
  flex-direction: row;
  border-radius: 8.55px; /* Reduced by 5% */
  gap: 8.55px; /* Reduced by 5% */
  max-height: 29.93px; /* Reduced by 5% */
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.theme.colors.greyText};
`;

const SubColoumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5.99px; /* Reduced by 5% */
`;

const Row = styled.div`
  display: flex;
  gap: 5.99px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-bottom: 7.70px; /* Reduced by 5% */
  align-items: center;
`;

const SessionStatusBox = styled.div`
  display: flex;
  overflow: hidden; /* Hides scrollbars */
`;

const FirstColumnSessioStatus = styled.div`
  flex: 1;
`;

const UploadButton = styled.div`
  flex: 1;
  display: flex;
  gap: 8.55px; /* Reduced by 5% */
  height: fit-content;
  align-items: center;
  margin-top: 17.1px; /* Reduced by 5% */
`;

const SecondColumnSessioStatus = styled.div`
  flex: 1;
`;

const Gap = styled.div`
  height: 18.81px; /* Reduced by 5% */
`;

const SessionStageBox = styled.div`
  flex: 1;
`;

const DocumentSealBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10.26px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
  flex: 1;
`;
const ColumnName = styled.div`
  color: ${(props) => props.theme.colors.greyText};
  font-size: 11.97px; /* Reduced by 5% */
`;

const BadgeColumnName = styled.div`
  color: ${(props) => props.theme.colors.greyText};
  font-size: 11.97px; /* Reduced by 5% */
  display: inline-block;
`;

const StageColumnName = styled(ColumnName)`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.greyText};
  font-size: 13.3px; /* Reduced by 5% */
`;

const NetworkLocation = styled.div`
  display: flex;
  flex-direction: column;
`;

const RowText = styled.span`
  color: grey;
  font-size: 11.97px; /* Reduced by 5% */
`;

const OnlineRowSign = styled.span`
  border-radius: 4.28px; /* Reduced by 5% */
  display: inline-block;
  width: 8.55px; /* Reduced by 5% */
  height: 8.55px; /* Reduced by 5% */
  background-color: #00b050;
`;

const OfflineRowSign = styled.span`
  border-radius: 4.28px; /* Reduced by 5% */
  display: inline-block;
  width: 8.55px; /* Reduced by 5% */
  height: 8.55px; /* Reduced by 5% */
  background-color: #920606;
`;

const PersonaDashboardText = styled.button`
  padding: 6.84px 13.68px; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  height: fit-content;
  border: none;
  background-color: #b471e0;
  color: white;
`;

const ColumnValue = styled.input<{ isEditable?: boolean }>`
  color: black;
  font-size: 12.31px; /* Reduced by 5% */
  font-weight: 342px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
  border: 0.86px solid #ccc; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  padding: 6.84px; /* Reduced by 5% */
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow-x: scroll;
  background-color: #f9f9f9;
  cursor: ${(props) => (props.isEditable ? "text" : "default")};
  scrollbar-width: none; /* Hides scrollbars */
  &::-webkit-scrollbar {
    display: none; /* Hides scrollbars */
  }
`;

const SessionColumnValue = styled.span`
  font-size: 13.87px; /* Reduced by 5% */
`;

const RowName = styled.span`
  color: black;
  font-size: 12.31px; /* Reduced by 5% */
  font-weight: 342px; /* Reduced by 5% */
  word-wrap: break-word;
  overflow-wrap: break-word;
  cursor: not-allowed;
`;

const Badge = styled.span<{ status?: string }>`
  background-color: ${(props) =>
    props.status == "Passed"
      ? "#B1E3C3"
      : props.status == "In progress"
        ? "#FFF8D8"
        : props.status == "Failed"
          ? "#FFE7EA"
          : "none"};
  padding: 6.08px 17.29px; /* Reduced by 5% */
  height: 13.68px; /* Reduced by 5% */
  font-size: 10.26px; /* Reduced by 5% */
  white-space: nowrap;
  color: ${(props) =>
    props.status == "Passed"
      ? "#343434"
      : props.status == "In progress"
        ? "#343434"
        : props.status == "Failed"
          ? "#EA4125"
          : "none"};
  width: fit-content;
  display: flex;
  align-items: center;
  font-weight: 600;
  justify-content: center;
  text-transform: uppercase;
  margin: 0 auto;
`;

const TabBox = styled.div`
  background-color: white;
  border-radius: 8.55px; /* Reduced by 5% */
`;

const Tabs = styled.div`
  display: flex;
  margin-top: 17.1px; /* Reduced by 5% */
  border-bottom: 1.71px solid #ccc; /* Reduced by 5% */
`;
const Tab = styled.div<{ isActive: boolean }>`
  padding: 15.39px 47.03px; /* Reduced by 5% */
  color: ${(props) => (props.isActive ? "#0E3E8F" : "#4B5563")};
  text-align: center;
  font-size: 12.31px; /* Reduced by 5% */
  cursor: pointer;
  border-bottom: ${(props) => (props.isActive ? "1.71px solid #007bff" : "none")};
  border-bottom-color: ${(props) => (props.isActive ? "#007bff" : "none")};
`;

const TabContent = styled.div`
  padding: 17.1px; /* Reduced by 5% */
  padding-top: 17.1px; /* Reduced by 5% */
  background-color: white;
  margin-top: 21.38px 25.65px; /* Reduced by 5% */
  overflow: hidden; /* Hides scrollbars */
  border-radius: 8.55px; /* Reduced by 5% */
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupCancelOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupHeader = styled.h2`
  text-align: center;
`;

const PopupCancelHeader = styled.h2`
  // text-align: center;
`;

const PopupDescription = styled.h4`
  text-align: left;
  margin-right: auto;
  font-weight: 342; /* Reduced by 5% */
`;

const PopupCancelDescription = styled.h4`
  text-align: left;
  margin-right: auto;
  font-weight: 342; /* Reduced by 5% */
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 17.1px; /* Reduced by 5% */
`;

const CheckboxCancelContainer = styled.div`
  display: flex;
  align-items: center;
  // margin-top: 17.1px; /* Reduced by 5% */
`;

const ButtonCheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const ButtonCancelCheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4.28px; /* Reduced by 5% */
  margin-bottom: 8.55px; /* Reduced by 5% */
  gap: 8.55px; /* Reduced by 5% */
`;

const ButtonCancelGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4.28px; /* Reduced by 5% */
  margin-bottom: 8.55px; /* Reduced by 5% */
  gap: 8.55px; /* Reduced by 5% */
`;

const ButtonGroupSignerDetail = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8.55px; /* Reduced by 5% */
`;

const RestartButtonGroup = styled(ButtonGroup)`
  margin-left: auto;
`;

const DisableAudioVideoButtonGroup = styled(ButtonGroup)`
  margin-left: auto;
`;

const SendReminderContainer = styled.div`
  background-color: white;
  padding: 17.1px; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  box-shadow: 0 3.42px 5.13px rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  width: 650px; /* Reduced by 5% */
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const PopupContainer = styled.div`
  background-color: white;
  padding: 17.1px; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  box-shadow: 0 3.42px 5.13px rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  width: 342px; /* Reduced by 5% */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ReminderPopupContainer = styled.div`
  background-color: white;
  padding: 17.1px; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  box-shadow: 0 3.42px 5.13px rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  width: 500px; /* Reduced by 5% */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PopupCancelContainer = styled.div`
  background-color: white;
  padding: 17.1px; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  box-shadow: 0 3.42px 5.13px rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  width: 437px; /* Reduced by 5% */
  display: flex;
  flex-direction: column;
  // align-items: center;
`;

const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 0 12.83px; /* Reduced by 5% */
`;
const InputCancelWrapper = styled.div`
  width: 100%;
  position: relative;
  // padding: 0 12.83px; /* Reduced by 5% */
`;

const InputLabel = styled.label<{ isFocused: boolean }>`
  position: absolute;
  left: ${(props) => (props.isFocused ? "10.26px" : "20.52px")}; /* Reduced by 5% */
  top: ${(props) => (props.isFocused ? "-8.55px" : "17.1px")}; /* Reduced by 5% */
  color: ${(props) => (props.isFocused ? "#007bff" : "grey")};
  font-size: ${(props) => (props.isFocused ? "9.32px" : "12.31px")}; /* Reduced by 5% */
  transition: all 0.3s ease;
  pointer-events: none;
`;

const TextareaField = styled.textarea`
  width: 100%;
  height: 95px; /* Reduced by 5% */
  padding: 11.4px; /* Reduced by 5% */
  margin: 7.6px 0; /* Reduced by 5% */
  font-family: inherit;
  border: 0.95px solid #ccc; /* Reduced by 5% */
  border-radius: 3.8px; /* Reduced by 5% */
  font-size: 14.25px; /* Reduced by 5% */
  padding-left: 11.4px;
  box-sizing: border-box;

  &:focus + ${InputLabel} {
    top: -11.4px;
    font-size: 11.4px;
    color: #007bff;
  }
`;

const InputCancelLabel = styled.label<{ isFocused: boolean }>`
  position: absolute;
  left: ${(props) => (props.isFocused ? "2.85px" : "13.3px")}; /* Reduced by 5% */
  top: ${(props) => (props.isFocused ? "-8.55px" : "17.1px")}; /* Reduced by 5% */
  color: ${(props) => (props.isFocused ? "#007bff" : "grey")};
  font-size: ${(props) => (props.isFocused ? "9.32px" : "12.31px")}; /* Reduced by 5% */
  transition: all 0.3s ease;
  pointer-events: none;
`;

const InputField = styled.input`
  width: 100%;
  padding: 10.26px; /* Reduced by 5% */
  margin: 6.84px 0; /* Reduced by 5% */
  border: 0.86px solid #ccc; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  font-size: 12.31px; /* Reduced by 5% */
  padding-left: 10.26px; /* Reduced by 5% */
  box-sizing: border-box;

  &:focus + ${InputLabel} {
    top: -8.55px; /* Reduced by 5% */
    font-size: 10.26px; /* Reduced by 5% */
    color: #007bff;
  }
`;

const NotesActionBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8.55px; /* Reduced by 5% */
  padding-bottom: 1.71px; /* Reduced by 5% */
`;

const NotesSessionStageBox = styled.div`
  display: flex;
  margin-top: 15.39px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
  gap: 25.65px; /* Reduced by 5% */
`;

const NotesContentBox = styled.div`
  display: flex;
  gap: 8.55px; /* Reduced by 5% */
`;

const NotesSubBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  justify-content: flex-end;
  background: white;
  padding: 17.1px; /* Reduced by 5% */
  padding-bottom: 3.42px; /* Reduced by 5% */
  border-radius: 8.55px; /* Reduced by 5% */
`;

const NotesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8.55px; /* Reduced by 5% */
`;

const NotesTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.secondary};
  font-size: 14.71px; /* Reduced by 5% */
`;
const EditText = styled.span`
  color: ${(props) => props.theme.colors.grey};
  cursor: pointer;
  font-size: 10.26px; /* Reduced by 5% */
  &:hover {
    text-decoration: underline;
  }
`;

const UploadIdButton = styled.button`
  padding: 6.84px 13.68px; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  height: fit-content;
  border: none;
  background-color: #06B050;
  color: white;
`;

const LoadingSpinner = styled.div`
  border: 4.18px solid rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  border-top: 2.09px solid white; /* Reduced by 5% */
  width: 11.4px; /* Reduced by 5% */
  height: 11.4px; /* Reduced by 5% */
  border-radius: 50%; /* Ensures the element is a perfect circle */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingDocName = styled.div`
  border: 4.18px solid rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  border-top: 2.09px solid white; /* Reduced by 5% */
  width: 11.4px; /* Reduced by 5% */
  height: 11.4px; /* Reduced by 5% */
  border-radius: 50%; /* Ensures the element is a perfect circle */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const UploadedImgContainer = styled.div`
  max-width: 261.25px; /* Reduced by 5% */
  border: 0.86px solid #ccc; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  overflow: hidden;
  margin-top: 8.55px; /* Reduced by 5% */
`;

const UploadedImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const DatePickerWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 0.86px solid #ccc; /* Reduced by 5% */
  border-radius: 6.84px; /* Reduced by 5% */
  box-shadow: 0 3.42px 5.13px rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  padding: 8.55px; /* Reduced by 5% */
`;

const ButtonGroupDate = styled.div`
  display: flex;
  gap: 8.55px; /* Reduced by 5% */
  margin-top: 8.55px; /* Reduced by 5% */
`;

const Button = styled.button<{ variant?: string }>`
  padding: 6.84px 13.68px; /* Reduced by 5% */
  border-radius: 3.42px; /* Reduced by 5% */
  cursor: pointer;
  ${({ variant }) =>
    variant === "save" &&
    `
    background-color: #007bff;
    color: white;
  `}

  ${({ variant }) =>
    variant === "cancel" &&
    `
    background-color: transparent;
    border: 0.86px solid #007bff;
    color: #007bff;
  `}
`;

const ToastContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const WordCount = styled.div`
  font-size: 10.26px; /* Reduced by 5% */
  color: grey;
  text-align: right;
`;
